import { EventEmitter } from '@evergis/event-emitter';
import { HubConnectionBuilder, HttpTransportType, HubConnectionState } from '@microsoft/signalr';
import ky, { HTTPError } from 'ky';
export { HTTPError, TimeoutError } from 'ky';
import { stringify } from 'query-string';
import { customAlphabet } from 'nanoid';
import { DomPainter } from '@evergis/sgis/es/painters/DomPainter/DomPainter';
import { Map } from '@evergis/sgis/es/Map';
import { TileLayer } from '@evergis/sgis/es/layers/TileLayer';
import { DynamicLayer } from '@evergis/sgis/es/layers/DynamicLayer';
import { FeatureLayer } from '@evergis/sgis';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = _getPrototypeOf(object);
    if (object === null) break;
  }

  return object;
}

function _get() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get = Reflect.get;
  } else {
    _get = function _get(target, property, receiver) {
      var base = _superPropBase(target, property);

      if (!base) return;
      var desc = Object.getOwnPropertyDescriptor(base, property);

      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }

      return desc.value;
    };
  }

  return _get.apply(this, arguments);
}

let HttpClient = /*#__PURE__*/function () {
  function HttpClient(options) {
    var _options$prefixUrl;

    if (options === void 0) {
      options = {};
    }

    _classCallCheck(this, HttpClient);

    this.ky = ky.extend(options);
    this.prefixUrl = ((_options$prefixUrl = options.prefixUrl) == null ? void 0 : _options$prefixUrl.toString()) || '';
  }

  _createClass(HttpClient, [{
    key: "extend",
    value: function extend(options) {
      var _options$prefixUrl2;

      this.ky = ky.extend(options);
      this.prefixUrl = ((_options$prefixUrl2 = options.prefixUrl) == null ? void 0 : _options$prefixUrl2.toString()) || '';
    }
  }, {
    key: "get",
    value: function get(url, params) {
      return this.ky.get(this.stripSlashes(url), {
        searchParams: qs(params)
      });
    }
  }, {
    key: "post",
    value: function post(url, body, params) {
      const options = kyOptions(params, body);
      return this.ky.post(this.stripSlashes(url), options);
    }
  }, {
    key: "put",
    value: function put(url, body, params) {
      const options = kyOptions(params, body);
      return this.ky.put(this.stripSlashes(url), options);
    }
  }, {
    key: "patch",
    value: function patch(url, body, params) {
      const options = kyOptions(params, body);
      return this.ky.patch(this.stripSlashes(url), options);
    }
  }, {
    key: "delete",
    value: function _delete(url, body, params) {
      const options = kyOptions(params, body);
      return this.ky.delete(this.stripSlashes(url), options);
    }
  }, {
    key: "createUrl",
    value: function createUrl(url, params) {
      const queryString = params ? "?" + qs(params) : '';
      return this.prefixUrl + this.stripSlashes(url) + queryString;
    }
  }, {
    key: "stripSlashes",
    value: function stripSlashes(url) {
      if (this.prefixUrl) {
        return url.replace(/^\//g, '');
      }

      return url;
    }
  }]);

  return HttpClient;
}();

function kyOptions(params, body) {
  const options = {
    searchParams: qs(params)
  };

  if (!isNotObject(body) || Array.isArray(body)) {
    options.json = body;
  } else {
    options.body = body;
  }

  return options;
}

function isNotObject(value) {
  return !(value !== void 0 && typeof value === 'object' && value !== null && value.constructor === Object);
}

function qs(params) {
  if (params === void 0) {
    params = {};
  }

  return stringify(params, {
    arrayFormat: 'comma'
  });
}

function toFormData(input) {
  if (input instanceof FormData) {
    return input;
  }

  return Object.keys(input).reduce((data, key) => {
    data.append(key, input[key]);
    return data;
  }, new FormData());
}

/* eslint-disable */

/* tslint:disable */

/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
let Service = /*#__PURE__*/_createClass(function Service(http) {
  _classCallCheck(this, Service);

  this.http = http;
});

const _excluded = ["taskId", "layerName"];
/**
 * @title Spatial Processing Core API
 * @version 1.0.0
 * @baseUrl /sp
 */

let UniversalSearchService = /*#__PURE__*/function (_Service) {
  _inherits(UniversalSearchService, _Service);

  var _super = /*#__PURE__*/_createSuper(UniversalSearchService);

  function UniversalSearchService() {
    _classCallCheck(this, UniversalSearchService);

    return _super.apply(this, arguments);
  }

  _createClass(UniversalSearchService, [{
    key: "getSearchResult",
    value:
    /**
     * No description
     *
     * @tags UniversalSearch
     * @name GetSearchResult
     * @operationId UniversalSearchController_GetSearchResult
     * @summary Returns search result.
     * @request GET:/search/{taskId}/{layerName}
     * @response `200` Success
     */
    function getSearchResult(_ref) {
      let {
        taskId,
        layerName
      } = _ref,
          query = _objectWithoutPropertiesLoose(_ref, _excluded);

      return this.http.get("/search/" + taskId + "/" + layerName, query).json();
    }
    /**
     * No description
     *
     * @tags UniversalSearch
     * @name GetSearchResult1
     * @operationId UniversalSearchController_GetSearchResult_1
     * @summary Returns search result.
     * @request GET:/search/{taskId}
     * @response `200` Success
     */

  }, {
    key: "getSearchResult1",
    value: function getSearchResult1(taskId) {
      return this.http.get("/search/" + taskId).json();
    }
  }]);

  return UniversalSearchService;
}(Service);

var ApiEvent;

(function (ApiEvent) {
  ApiEvent["ConnectionLost"] = "ConnectionLost";
  ApiEvent["Unauthorized"] = "Unauthorized";
  ApiEvent["SessionClosed"] = "SessionClosed";
})(ApiEvent || (ApiEvent = {}));

/**
 * @title Spatial Processing Core API
 * @version 1.0.0
 * @baseUrl /sp
 */

let BulkOperationsService = /*#__PURE__*/function (_Service) {
  _inherits(BulkOperationsService, _Service);

  var _super = /*#__PURE__*/_createSuper(BulkOperationsService);

  function BulkOperationsService() {
    _classCallCheck(this, BulkOperationsService);

    return _super.apply(this, arguments);
  }

  _createClass(BulkOperationsService, [{
    key: "batchResourcesPermissionsSet",
    value:
    /**
     * No description
     *
     * @tags BulkOperations
     * @name BatchResourcesPermissionsSet
     * @operationId BulkOperationsController_BatchResourcesPermissionsSet
     * @summary Perform resources set acl access batch operation.
     * @request PUT:/bulk/resources/permissions
     * @response `200` Success
     */
    function batchResourcesPermissionsSet(data) {
      return this.http.put("/bulk/resources/permissions", data).json();
    }
  }]);

  return BulkOperationsService;
}(Service);

let BulkOperations = /*#__PURE__*/function (_BulkOperationsServic) {
  _inherits(BulkOperations, _BulkOperationsServic);

  var _super = /*#__PURE__*/_createSuper(BulkOperations);

  function BulkOperations() {
    _classCallCheck(this, BulkOperations);

    return _super.apply(this, arguments);
  }

  return _createClass(BulkOperations);
}(BulkOperationsService);

/**
 * @title Spatial Processing Core API
 * @version 1.0.0
 * @baseUrl /sp
 */

let SecurityService = /*#__PURE__*/function (_Service) {
  _inherits(SecurityService, _Service);

  var _super = /*#__PURE__*/_createSuper(SecurityService);

  function SecurityService() {
    _classCallCheck(this, SecurityService);

    return _super.apply(this, arguments);
  }

  _createClass(SecurityService, [{
    key: "findUserByNameByRoles",
    value:
    /**
     * No description
     *
     * @tags SecurityService
     * @name FindUserByNameByRoles
     * @operationId SecurityServiceController_FindUserByNameByRoles
     * @summary Get users list with given roles list.
     * @request GET:/security/findUsersWithRoles
     * @response `200` Success
     */
    function findUserByNameByRoles(query) {
      return this.http.get("/security/findUsersWithRoles", query).json();
    }
    /**
     * No description
     *
     * @tags SecurityService
     * @name GetUsersAndRoles
     * @operationId SecurityServiceController_GetUsersAndRoles
     * @summary Get users and roles list by filter.
     * @request GET:/security/usersandroles
     * @response `200` Success
     */

  }, {
    key: "getUsersAndRoles",
    value: function getUsersAndRoles(query) {
      return this.http.get("/security/usersandroles", query).json();
    }
    /**
     * No description
     *
     * @tags SecurityService
     * @name FindUserByName
     * @operationId SecurityServiceController_FindUserByName
     * @summary Returns the list of users found by username.
     * @request GET:/security/users
     * @response `200` Success
     */

  }, {
    key: "findUserByName",
    value: function findUserByName(query) {
      return this.http.get("/security/users", query).json();
    }
    /**
     * @description This method requires superuser permission.
     *
     * @tags SecurityService
     * @name GetPolicyList
     * @operationId SecurityServiceController_GetPolicyList
     * @summary Returns the list of server authorization policies of the given type.
     * @request GET:/security/policies
     * @response `200` Success
     */

  }, {
    key: "getPolicyList",
    value: function getPolicyList(query) {
      return this.http.get("/security/policies", query).json();
    }
    /**
     * @description This method requires superuser permission.
     *
     * @tags SecurityService
     * @name RemovePolicy
     * @operationId SecurityServiceController_RemovePolicy
     * @summary Removes the policy of the given type with the given role. If no such policy is found, nothing is done, and OK response is returned.
     * @request DELETE:/security/policies
     * @response `200` Success
     */

  }, {
    key: "removePolicy",
    value: function removePolicy(query) {
      return this.http.delete("/security/policies", null, query).then(() => {});
    }
    /**
     * @description This method requires superuser permission.
     *
     * @tags SecurityService
     * @name SetPolicy
     * @operationId SecurityServiceController_SetPolicy
     * @summary Adds the given policy to the server policy list. If a policy with the same type and user role already exists, it replaces the existing policy with the new one.
     * @request POST:/security/policies
     * @response `200` Success
     */

  }, {
    key: "setPolicy",
    value: function setPolicy(data) {
      return this.http.post("/security/policies", data).then(() => {});
    }
  }]);

  return SecurityService;
}(Service);

let Security = /*#__PURE__*/function (_SecurityService) {
  _inherits(Security, _SecurityService);

  var _super = /*#__PURE__*/_createSuper(Security);

  function Security(http, _ref) {
    var _this;

    let {
      username,
      roles
    } = _ref;

    _classCallCheck(this, Security);

    _this = _super.call(this, http);
    _this.ownerName = '';
    _this.ownerRoles = [];
    _this.ownerName = username;
    _this.ownerRoles = roles;
    return _this;
  }

  _createClass(Security, [{
    key: "reset",
    value: function reset() {
      this.ownerName = '';
      this.ownerRoles = [];
    }
  }]);

  return Security;
}(SecurityService);

/**
 * @title Spatial Processing Core API
 * @version 1.0.0
 * @baseUrl /sp
 */

let StaticContentService = /*#__PURE__*/function (_Service) {
  _inherits(StaticContentService, _Service);

  var _super = /*#__PURE__*/_createSuper(StaticContentService);

  function StaticContentService() {
    _classCallCheck(this, StaticContentService);

    return _super.apply(this, arguments);
  }

  _createClass(StaticContentService, [{
    key: "downloadFile",
    value:
    /**
     * No description
     *
     * @tags StaticContentService
     * @name DownloadFile
     * @operationId StaticContentServiceController_DownloadFile
     * @summary Returns a file stream by fileId.
     * @request GET:/upload/file
     * @response `200` Success
     */
    function downloadFile(query) {
      return this.http.get("/upload/file", query).blob();
    }
    /**
     * No description
     *
     * @tags StaticContentService
     * @name UploadFile
     * @operationId StaticContentServiceController_UploadFile
     * @summary Upload file to temporary session storage.
     * @request POST:/upload/file
     * @response `200` Success
     */

  }, {
    key: "uploadFile",
    value: function uploadFile(data) {
      return this.http.post("/upload/file", toFormData(data)).json();
    }
    /**
     * No description
     *
     * @tags StaticContentService
     * @name DeleteFile
     * @operationId StaticContentServiceController_DeleteFile
     * @summary Delete file from temporary session storage.
     * @request DELETE:/upload/file
     * @response `200` Success
     */

  }, {
    key: "deleteFile",
    value: function deleteFile(query) {
      return this.http.delete("/upload/file", null, query).then(() => {});
    }
    /**
     * No description
     *
     * @tags StaticContentService
     * @name GetFileInfo
     * @operationId StaticContentServiceController_GetFileInfo
     * @summary Returns a file info download by url.
     * @request GET:/upload/fileInfo
     * @response `200` Success
     */

  }, {
    key: "getFileInfo",
    value: function getFileInfo(query) {
      return this.http.get("/upload/fileInfo", query).json();
    }
  }]);

  return StaticContentService;
}(Service);

let FileUpload = /*#__PURE__*/function (_StaticContentService) {
  _inherits(FileUpload, _StaticContentService);

  var _super = /*#__PURE__*/_createSuper(FileUpload);

  function FileUpload() {
    _classCallCheck(this, FileUpload);

    return _super.apply(this, arguments);
  }

  _createClass(FileUpload, [{
    key: "upload",
    value: function upload(file, rewrite) {
      return this.uploadFile({
        file,
        rewrite: !!rewrite
      });
    }
  }]);

  return FileUpload;
}(StaticContentService);

/**
 * @title Spatial Processing Core API
 * @version 1.0.0
 * @baseUrl /sp
 */

let FiltersService = /*#__PURE__*/function (_Service) {
  _inherits(FiltersService, _Service);

  var _super = /*#__PURE__*/_createSuper(FiltersService);

  function FiltersService() {
    _classCallCheck(this, FiltersService);

    return _super.apply(this, arguments);
  }

  _createClass(FiltersService, [{
    key: "get",
    value:
    /**
     * No description
     *
     * @tags FiltersService
     * @name Get
     * @operationId FiltersServiceController_Get
     * @summary Returns the filter by its id.
     * @request GET:/filters/{id}
     * @response `200` Success
     */
    function get(id) {
      return this.http.get("/filters/" + id).text();
    }
    /**
     * No description
     *
     * @tags FiltersService
     * @name Update
     * @operationId FiltersServiceController_Update
     * @summary Replaces a filter and gives it a new id.
     * @request POST:/filters/{id}
     * @response `200` Success
     */

  }, {
    key: "update",
    value: function update(id, data) {
      return this.http.post("/filters/" + id, data).json();
    }
    /**
     * No description
     *
     * @tags FiltersService
     * @name Create
     * @operationId FiltersServiceController_Create
     * @summary Creates a new filter.
     * @request POST:/filters
     * @response `200` Success
     */

  }, {
    key: "create",
    value: function create(data) {
      return this.http.post("/filters", data).json();
    }
  }]);

  return FiltersService;
}(Service);

let Filters = /*#__PURE__*/function (_FiltersService) {
  _inherits(Filters, _FiltersService);

  var _super = /*#__PURE__*/_createSuper(Filters);

  function Filters() {
    _classCallCheck(this, Filters);

    return _super.apply(this, arguments);
  }

  return _createClass(Filters);
}(FiltersService);

/**
 * @title Spatial Processing Core API
 * @version 1.0.0
 * @baseUrl /sp
 */

let ImportService = /*#__PURE__*/function (_Service) {
  _inherits(ImportService, _Service);

  var _super = /*#__PURE__*/_createSuper(ImportService);

  function ImportService() {
    _classCallCheck(this, ImportService);

    return _super.apply(this, arguments);
  }

  _createClass(ImportService, [{
    key: "getDataSchema",
    value:
    /**
     * No description
     *
     * @tags ImportService
     * @name GetDataSchema
     * @operationId ImportServiceController_GetDataSchema
     * @summary Using a file uploaded to the file upload service, reads the headers of the file and returns the information about data schema of all layers in that file, available for import.
     * @request GET:/import/dataSchema
     * @response `200` Success
     */
    function getDataSchema(query) {
      return this.http.get("/import/dataSchema", query).json();
    }
    /**
     * No description
     *
     * @tags ImportService
     * @name GetFeaturesCount
     * @operationId ImportServiceController_GetFeaturesCount
     * @summary Returns the features count of the given file in temporary static storage.
     * @request POST:/import/count
     * @response `200` Success
     */

  }, {
    key: "getFeaturesCount",
    value: function getFeaturesCount(data) {
      return this.http.post("/import/count", data).json();
    }
    /**
     * No description
     *
     * @tags ImportService
     * @name ReadPart
     * @operationId ImportServiceController_ReadPart
     * @summary Returns the features of the given file in temporary static storage.
     * @request GET:/import/read
     * @response `200` Success
     */

  }, {
    key: "readPart",
    value: function readPart(query) {
      return this.http.get("/import/read", query).then(() => {});
    }
    /**
     * No description
     *
     * @tags ImportService
     * @name GetExternalWmsLayers
     * @operationId ImportServiceController_GetExternalWmsLayers
     * @summary Get list of external WMS layers.
     * @request GET:/import/wms
     * @response `200` Success
     */

  }, {
    key: "getExternalWmsLayers",
    value: function getExternalWmsLayers(query) {
      return this.http.get("/import/wms", query).json();
    }
    /**
     * No description
     *
     * @tags ImportService
     * @name GetExternalPbfLayers
     * @operationId ImportServiceController_GetExternalPbfLayers
     * @summary Get list of external PBF layers.
     * @request GET:/import/pbf
     * @response `200` Success
     */

  }, {
    key: "getExternalPbfLayers",
    value: function getExternalPbfLayers(query) {
      return this.http.get("/import/pbf", query).json();
    }
    /**
     * No description
     *
     * @tags ImportService
     * @name GetExternalArcGisLayers
     * @operationId ImportServiceController_GetExternalArcGisLayers
     * @summary Get list of external ArcGis map service layers.
     * @request GET:/import/arcgismapservice
     * @response `200` Success
     */

  }, {
    key: "getExternalArcGisLayers",
    value: function getExternalArcGisLayers(query) {
      return this.http.get("/import/arcgismapservice", query).json();
    }
    /**
     * No description
     *
     * @tags ImportService
     * @name GetRasterAttributes
     * @operationId ImportServiceController_GetRasterAttributes
     * @summary Parse raster attributes from file name.
     * @request GET:/import/rasterAttributes
     * @response `200` Success
     */

  }, {
    key: "getRasterAttributes",
    value: function getRasterAttributes(query) {
      return this.http.get("/import/rasterAttributes", query).json();
    }
    /**
     * No description
     *
     * @tags ImportService
     * @name GetRasterMeta
     * @operationId ImportServiceController_GetRasterMeta
     * @summary Get raster meta data.
     * @request GET:/import/rasterMeta
     * @response `200` Success
     */

  }, {
    key: "getRasterMeta",
    value: function getRasterMeta(query) {
      return this.http.get("/import/rasterMeta", query).json();
    }
  }]);

  return ImportService;
}(Service);

let Import = /*#__PURE__*/function (_ImportService) {
  _inherits(Import, _ImportService);

  var _super = /*#__PURE__*/_createSuper(Import);

  function Import() {
    _classCallCheck(this, Import);

    return _super.apply(this, arguments);
  }

  return _createClass(Import);
}(ImportService);

/**
 * @title Spatial Processing Core API
 * @version 1.0.0
 * @baseUrl /sp
 */

let NotificationService = /*#__PURE__*/function (_Service) {
  _inherits(NotificationService, _Service);

  var _super = /*#__PURE__*/_createSuper(NotificationService);

  function NotificationService() {
    _classCallCheck(this, NotificationService);

    return _super.apply(this, arguments);
  }

  _createClass(NotificationService, [{
    key: "getSubscriptionList",
    value:
    /**
     * No description
     *
     * @tags NotificationService
     * @name GetSubscriptionList
     * @operationId NotificationServiceController_GetSubscriptionList
     * @summary Returns a list of notification tags that the current session is subscribed to.
     * @request GET:/notifications/subscribes
     * @response `200` Success
     */
    function getSubscriptionList() {
      return this.http.get("/notifications/subscribes").json();
    }
    /**
     * No description
     *
     * @tags NotificationService
     * @name SubscribeOperation
     * @operationId NotificationServiceController_SubscribeOperation
     * @summary Subscribe current session by subscribe tag. A subscribed session will receive all notifications added for the specified tag.
     * @request POST:/notifications/subscribes
     * @response `200` Success
     */

  }, {
    key: "subscribeOperation",
    value: function subscribeOperation(query) {
      return this.http.post("/notifications/subscribes", null, query).then(() => {});
    }
    /**
     * No description
     *
     * @tags NotificationService
     * @name UnsubscribeOperation
     * @operationId NotificationServiceController_UnsubscribeOperation
     * @summary Unsubscribe from receiving notifications that come for the specified tag.
     * @request DELETE:/notifications/subscribes
     * @response `200` Success
     */

  }, {
    key: "unsubscribeOperation",
    value: function unsubscribeOperation(query) {
      return this.http.delete("/notifications/subscribes", null, query).then(() => {});
    }
    /**
     * No description
     *
     * @tags NotificationService
     * @name SubscribeListOperation
     * @operationId NotificationServiceController_SubscribeListOperation
     * @summary Subscribe current session by subscribe tags. A subscribed session will receive all notifications added for the specified tags.
     * @request POST:/notifications/subscribe-list
     * @response `200` Success
     */

  }, {
    key: "subscribeListOperation",
    value: function subscribeListOperation(data) {
      return this.http.post("/notifications/subscribe-list", data).then(() => {});
    }
    /**
     * No description
     *
     * @tags NotificationService
     * @name UnsubscribeListOperation
     * @operationId NotificationServiceController_UnsubscribeListOperation
     * @summary Unsubscribe from receiving notifications that come for the specified tags.
     * @request POST:/notifications/unsubscribe-list
     * @response `200` Success
     */

  }, {
    key: "unsubscribeListOperation",
    value: function unsubscribeListOperation(data) {
      return this.http.post("/notifications/unsubscribe-list", data).then(() => {});
    }
  }]);

  return NotificationService;
}(Service);

var ConnectionStatus;

(function (ConnectionStatus) {
  ConnectionStatus["Initialized"] = "Initialized";
  ConnectionStatus["Connected"] = "Connected";
  ConnectionStatus["Break"] = "Break";
  ConnectionStatus["Lost"] = "Lost";
  ConnectionStatus["SessionClosed"] = "SessionClosed";
})(ConnectionStatus || (ConnectionStatus = {}));

const SUBSCRIPTION_DELAY = 500;
const KEEP_ALIVE_INTERVAL = 5 * 1000;
let Notification = /*#__PURE__*/function (_NotificationService) {
  _inherits(Notification, _NotificationService);

  var _super = /*#__PURE__*/_createSuper(Notification);

  function Notification(http, api, keepAlive) {
    var _this;

    if (keepAlive === void 0) {
      keepAlive = false;
    }

    _classCallCheck(this, Notification);

    _this = _super.call(this, http);
    _this.api = api;
    _this.MAX_WS_RECONNECT_TRIES = 10;
    _this.keepAlive = false;
    _this.reconnectTries = 0;
    _this.subscriptions = [];
    _this._connectStatus = ConnectionStatus.Initialized;

    _this.onWsConnected = () => {
      _this.connectStatus = ConnectionStatus.Connected;

      if (_this.keepAlive) {
        _this.keepAliveTimeout = setInterval(() => {
          if (_this.ws) {
            _this.ws.send(JSON.stringify({
              keepAlive: true
            }));
          }
        }, KEEP_ALIVE_INTERVAL);
      } // TODO: comment for now. it launch endless flow of reconnections
      // this.reconnectTries = 0;

    };

    _this.onWsClosed = event => {
      if (event.code === 4001
      /* SessionClosed */
      || event.code === 4002
      /* InvalidSession */
      ) {
        _this.connectStatus = ConnectionStatus.SessionClosed;
      } else if (_this.reconnectTries < _this.MAX_WS_RECONNECT_TRIES) {
        _this.connectStatus = ConnectionStatus.Break;
        _this.reconnectTries++;

        if (_this.ws) {
          _this.ws.onopen = null;
          _this.ws.onclose = null;
          _this.ws.onmessage = null;
          _this.ws = void 0;
        }

        _this.keepAliveTimeout && clearInterval(_this.keepAliveTimeout);
        setTimeout(() => {
          _this.connect();
        }, 0);
      } else {
        _this.connectStatus = ConnectionStatus.Lost;
      }
    };

    _this.onWsMessage = event => {
      let message = {};

      try {
        message = JSON.parse(event.data);
      } catch (e) {
        console.debug('Failed to parse ws message from sp.'); // ignore
      }

      if (message.type === 'notification' && message.data) {
        const {
          tag,
          data
        } = message.data;
        tag && _this.emitter.emit(tag, new NotificationEvent(data));
      }
    };

    _this.emitter = new EventEmitter();
    _this.keepAlive = keepAlive;
    return _this;
  } // @ts-ignore


  _createClass(Notification, [{
    key: "connectStatus",
    get: function get() {
      return this._connectStatus;
    } // @ts-ignore
    ,
    set: function set(connectStatus) {
      this.emitter.emit("ConnectionStatus"
      /* ConnectionStatus */
      , new NotificationEvent(connectStatus));
      this._connectStatus = connectStatus;
    }
  }, {
    key: "currentWs",
    get: function get() {
      return this.ws;
    }
  }, {
    key: "on",
    value: function on(tag, handler) {
      this.emitter.on(tag, handler);
    }
  }, {
    key: "off",
    value: function off(tag, handler) {
      this.emitter.off(tag, handler);
    }
  }, {
    key: "subscribe",
    value: async function subscribe(tag) {
      this.subscriptions.push(tag);
      setTimeout(() => {
        if (!this.api.isShared && this.subscriptions.length) {
          this.subscribeListOperation(this.subscriptions);
        }

        this.subscriptions = [];
      }, SUBSCRIPTION_DELAY);
    }
  }, {
    key: "unsubscribe",
    value: async function unsubscribe(tag) {
      const subscriptions = await this.getSubscriptionList();

      if (subscriptions.includes(tag)) {
        return this.unsubscribeOperation({
          tag
        });
      }
    }
  }, {
    key: "connectWs",
    value: function connectWs(url) {
      const urlWithWsScheme = url.replace('http://', 'ws://').replace('https://', 'wss://');
      this.wsUrl = urlWithWsScheme;
      this.connect();
    }
  }, {
    key: "connect",
    value: function connect() {
      if (this.wsUrl) {
        this.ws = new WebSocket(this.wsUrl);
        this.ws.onopen = this.onWsConnected;
        this.ws.onclose = this.onWsClosed;
        this.ws.onmessage = this.onWsMessage;
      } else {
        console.warn('Connection to WebSocket not allowed. wsUrl not provided');
      }
    }
  }]);

  return Notification;
}(NotificationService);
let NotificationEvent = /*#__PURE__*/_createClass(function NotificationEvent(data) {
  _classCallCheck(this, NotificationEvent);

  this.data = data;
});

/**
 * @title Spatial Processing Core API
 * @version 1.0.0
 * @baseUrl /sp
 */

let SchedulerService = /*#__PURE__*/function (_Service) {
  _inherits(SchedulerService, _Service);

  var _super = /*#__PURE__*/_createSuper(SchedulerService);

  function SchedulerService() {
    _classCallCheck(this, SchedulerService);

    return _super.apply(this, arguments);
  }

  _createClass(SchedulerService, [{
    key: "getTaskList",
    value:
    /**
     * No description
     *
     * @tags SchedulerService
     * @name GetTaskList
     * @operationId SchedulerServiceController_GetTaskList
     * @summary Returns the list of the planned and complete server tasks.
     * @request GET:/scheduler/tasks
     * @response `200` Success
     */
    function getTaskList(query) {
      return this.http.get("/scheduler/tasks", query).json();
    }
    /**
     * No description
     *
     * @tags SchedulerService
     * @name GetTaskInfo
     * @operationId SchedulerServiceController_GetTaskInfo
     * @summary Returns the information about the server task.
     * @request GET:/scheduler/tasks/{id}
     * @response `200` Success
     */

  }, {
    key: "getTaskInfo",
    value: function getTaskInfo(id) {
      return this.http.get("/scheduler/tasks/" + id).json();
    }
    /**
     * No description
     *
     * @tags SchedulerService
     * @name GetTaskProgress
     * @operationId SchedulerServiceController_GetTaskProgress
     * @summary Returns the progress of server task.
     * @request GET:/scheduler/tasks/{id}/progress
     * @response `200` Success
     */

  }, {
    key: "getTaskProgress",
    value: function getTaskProgress(id) {
      return this.http.get("/scheduler/tasks/" + id + "/progress").json();
    }
    /**
     * No description
     *
     * @tags SchedulerService
     * @name CancelTask
     * @operationId SchedulerServiceController_CancelTask
     * @summary Cancel task execution by given id.
     * @request POST:/scheduler/tasks/{id}/cancel
     * @response `200` Success
     */

  }, {
    key: "cancelTask",
    value: function cancelTask(id) {
      return this.http.post("/scheduler/tasks/" + id + "/cancel", null).json();
    }
    /**
     * No description
     *
     * @tags SchedulerService
     * @name StartCopyTask
     * @operationId SchedulerServiceController_StartCopyTask
     * @summary Plans the execution of a 'copy' server task.
     * @request POST:/scheduler/tasks#type=copy
     * @response `200` Success
     */

  }, {
    key: "startCopyTask",
    value: function startCopyTask(data) {
      return this.http.post("/scheduler/tasks", data, {
        type: 'copy'
      }).json();
    }
    /**
     * No description
     *
     * @tags SchedulerService
     * @name StartAggregateTask
     * @operationId SchedulerServiceController_StartAggregateTask
     * @summary Plans the execution of a 'aggregate' server task.
     * @request POST:/scheduler/tasks#type=aggregate
     * @response `200` Success
     */

  }, {
    key: "startAggregateTask",
    value: function startAggregateTask(data) {
      return this.http.post("/scheduler/tasks", data, {
        type: 'aggregate'
      }).json();
    }
    /**
     * No description
     *
     * @tags SchedulerService
     * @name StartBufferTask
     * @operationId SchedulerServiceController_StartBufferTask
     * @summary Plans the execution of a 'buffer' server task.
     * @request POST:/scheduler/tasks#type=buffer
     * @response `200` Success
     */

  }, {
    key: "startBufferTask",
    value: function startBufferTask(data) {
      return this.http.post("/scheduler/tasks", data, {
        type: 'buffer'
      }).json();
    }
    /**
     * No description
     *
     * @tags SchedulerService
     * @name StartPrintTask
     * @operationId SchedulerServiceController_StartPrintTask
     * @summary Plans the execution of a 'print' server task.
     * @request POST:/scheduler/tasks#type=print
     * @response `200` Success
     */

  }, {
    key: "startPrintTask",
    value: function startPrintTask(data) {
      return this.http.post("/scheduler/tasks", data, {
        type: 'print'
      }).json();
    }
    /**
     * No description
     *
     * @tags SchedulerService
     * @name StartTilingTask
     * @operationId SchedulerServiceController_StartTilingTask
     * @summary Plans the execution of a 'tiling' server task.
     * @request POST:/scheduler/tasks#type=tiling
     * @response `200` Success
     */

  }, {
    key: "startTilingTask",
    value: function startTilingTask(data) {
      return this.http.post("/scheduler/tasks", data, {
        type: 'tiling'
      }).json();
    }
    /**
     * No description
     *
     * @tags SchedulerService
     * @name StartNetCdfTask
     * @operationId SchedulerServiceController_StartNetCdfTask
     * @summary Plans the execution of a 'netcdf' server task.
     * @request POST:/scheduler/tasks#type=netcdf
     * @response `200` Success
     */

  }, {
    key: "startNetCdfTask",
    value: function startNetCdfTask(data) {
      return this.http.post("/scheduler/tasks", data, {
        type: 'netcdf'
      }).json();
    }
    /**
     * No description
     *
     * @tags SchedulerService
     * @name StartRouteTask
     * @operationId SchedulerServiceController_StartRouteTask
     * @summary Plans the execution of a 'availability area build' server task.
     * @request POST:/scheduler/tasks#type=route
     * @response `200` Success
     */

  }, {
    key: "startRouteTask",
    value: function startRouteTask(data) {
      return this.http.post("/scheduler/tasks", data, {
        type: 'route'
      }).json();
    }
    /**
     * No description
     *
     * @tags SchedulerService
     * @name StartUnionTask
     * @operationId SchedulerServiceController_StartUnionTask
     * @summary Plans the execution of a 'union' server task.
     * @request POST:/scheduler/tasks#type=union
     * @response `200` Success
     */

  }, {
    key: "startUnionTask",
    value: function startUnionTask(data) {
      return this.http.post("/scheduler/tasks", data, {
        type: 'union'
      }).json();
    }
    /**
     * No description
     *
     * @tags SchedulerService
     * @name StartOverlayTask
     * @operationId SchedulerServiceController_StartOverlayTask
     * @summary Plans the execution of a 'subtraction' server task.
     * @request POST:/scheduler/tasks#type=overlay
     * @response `200` Success
     */

  }, {
    key: "startOverlayTask",
    value: function startOverlayTask(data) {
      return this.http.post("/scheduler/tasks", data, {
        type: 'overlay'
      }).json();
    }
    /**
     * No description
     *
     * @tags SchedulerService
     * @name StartFilterCopyTask
     * @operationId SchedulerServiceController_StartFilterCopyTask
     * @summary Plans the execution of a 'filter copy' server task.
     * @request POST:/scheduler/tasks#type=filterCopy
     * @response `200` Success
     */

  }, {
    key: "startFilterCopyTask",
    value: function startFilterCopyTask(data) {
      return this.http.post("/scheduler/tasks", data, {
        type: 'filterCopy'
      }).json();
    }
    /**
     * No description
     *
     * @tags SchedulerService
     * @name StartPipelineTask
     * @operationId SchedulerServiceController_StartPipelineTask
     * @summary Plans the execution of a 'pipeline' server task.
     * @request POST:/scheduler/tasks#type=pipeline
     * @response `200` Success
     */

  }, {
    key: "startPipelineTask",
    value: function startPipelineTask(data) {
      return this.http.post("/scheduler/tasks", data, {
        type: 'pipeline'
      }).json();
    }
    /**
     * No description
     *
     * @tags SchedulerService
     * @name StartEditAttributesBatch
     * @operationId SchedulerServiceController_StartEditAttributesBatch
     * @summary Plans the execution of a 'edit attributes' server task.
     * @request POST:/scheduler/tasks#type=editAttributes
     * @response `200` Success
     */

  }, {
    key: "startEditAttributesBatch",
    value: function startEditAttributesBatch(data) {
      return this.http.post("/scheduler/tasks", data, {
        type: 'editAttributes'
      }).json();
    }
    /**
     * No description
     *
     * @tags SchedulerService
     * @name UniversalSearchTask
     * @operationId SchedulerServiceController_UniversalSearchTask
     * @summary Plans the execution of a 'edit attributes' server task.
     * @request POST:/scheduler/tasks#type=universalSearch
     * @response `200` Success
     */

  }, {
    key: "universalSearchTask",
    value: function universalSearchTask(data) {
      return this.http.post("/scheduler/tasks", data, {
        type: 'universalSearch'
      }).json();
    }
  }]);

  return SchedulerService;
}(Service);

let Scheduler = /*#__PURE__*/function (_SchedulerService) {
  _inherits(Scheduler, _SchedulerService);

  var _super = /*#__PURE__*/_createSuper(Scheduler);

  function Scheduler() {
    _classCallCheck(this, Scheduler);

    return _super.apply(this, arguments);
  }

  _createClass(Scheduler, [{
    key: "init",
    value: function init(notification) {
      this.notification = notification;
      return this.notification.subscribe("server_task"
      /* ServerTask */
      );
    }
  }, {
    key: "runCopyTask",
    value: async function runCopyTask(parameters) {
      const {
        taskId
      } = await this.startCopyTask(parameters);
      return this.processTaskId(taskId);
    }
  }, {
    key: "runBufferTask",
    value: async function runBufferTask(parameters) {
      const {
        taskId
      } = await this.startBufferTask(parameters);
      return this.processTaskId(taskId);
    }
  }, {
    key: "runUnionTask",
    value: async function runUnionTask(parameters) {
      const {
        taskId
      } = await this.startUnionTask(parameters);
      return this.processTaskId(taskId);
    }
  }, {
    key: "runPrintTask",
    value: async function runPrintTask(parameters) {
      const {
        taskId
      } = await this.startPrintTask(parameters);
      return this.processTaskId(taskId);
    }
  }, {
    key: "runTilingTask",
    value: async function runTilingTask(parameters) {
      const {
        taskId
      } = await this.startTilingTask(parameters);
      return this.processTaskId(taskId);
    }
  }, {
    key: "runRouteTask",
    value: async function runRouteTask(parameters) {
      const {
        taskId
      } = await this.startRouteTask(parameters);
      return this.processTaskId(taskId);
    }
  }, {
    key: "runOverlayTask",
    value: async function runOverlayTask(parameters) {
      const {
        taskId
      } = await this.startOverlayTask(parameters);
      return this.processTaskId(taskId);
    }
  }, {
    key: "runFilterCopyTask",
    value: async function runFilterCopyTask(parameters) {
      const {
        taskId
      } = await this.startFilterCopyTask(parameters);
      return this.processTaskId(taskId);
    }
  }, {
    key: "runPipelineTask",
    value: async function runPipelineTask(parameters) {
      const {
        taskId
      } = await this.startPipelineTask(parameters);
      return this.processTaskId(taskId);
    }
  }, {
    key: "runEditAttributesTask",
    value: async function runEditAttributesTask(parameters) {
      const {
        taskId
      } = await this.startEditAttributesBatch(parameters);
      return this.processTaskId(taskId);
    }
  }, {
    key: "waitTaskCompleted",
    value: async function waitTaskCompleted(id) {
      return new Promise(async (resolve, reject) => {
        const taskProgress = await this.getTaskProgress(id);
        this.resolveTaskStatus(taskProgress, resolve, reject);

        const taskResultCallback = async _ref => {
          let {
            data
          } = _ref;
          const taskFinished = data.taskId === id && data.status && ['Completed', 'Failed', 'Canceled'].includes(data.status);

          if (taskFinished) {
            const taskProgress = await this.getTaskProgress(id);
            this.notification && this.notification.off("server_task"
            /* ServerTask */
            , taskResultCallback);
            this.resolveTaskStatus(taskProgress, resolve, reject);
          }
        };

        this.notification && this.notification.on("server_task"
        /* ServerTask */
        , taskResultCallback);
      });
    }
  }, {
    key: "resolveTaskStatus",
    value: function resolveTaskStatus(taskProgress, resolve, reject) {
      if (taskProgress.status === 'Completed') {
        resolve(taskProgress);
      } else if (taskProgress.status === 'Failed' || taskProgress.status === 'Canceled') {
        reject(taskProgress.status);
      }
    }
  }, {
    key: "processTaskId",
    value: function processTaskId(taskId) {
      if (taskId) {
        return this.waitTaskCompleted(taskId);
      } else {
        throw new Error("Task was started with no testId");
      }
    }
  }]);

  return Scheduler;
}(SchedulerService);

const _excluded$1 = ["name"],
      _excluded2 = ["name"],
      _excluded3 = ["name"],
      _excluded4 = ["name", "id"],
      _excluded5 = ["name", "id"],
      _excluded6 = ["name", "id"],
      _excluded7 = ["name", "x", "y", "z"],
      _excluded8 = ["name"],
      _excluded9 = ["name"],
      _excluded10 = ["name"],
      _excluded11 = ["name"],
      _excluded12 = ["name"],
      _excluded13 = ["name"],
      _excluded14 = ["name"],
      _excluded15 = ["name"],
      _excluded16 = ["name"],
      _excluded17 = ["name"],
      _excluded18 = ["name"],
      _excluded19 = ["layerName"],
      _excluded20 = ["name", "id"];
/**
 * @title Spatial Processing Core API
 * @version 1.0.0
 * @baseUrl /sp
 */

let LayersService = /*#__PURE__*/function (_Service) {
  _inherits(LayersService, _Service);

  var _super = /*#__PURE__*/_createSuper(LayersService);

  function LayersService() {
    _classCallCheck(this, LayersService);

    return _super.apply(this, arguments);
  }

  _createClass(LayersService, [{
    key: "getLayersList",
    value:
    /**
     * No description
     *
     * @tags Layers
     * @name GetLayersList
     * @operationId LayersController_GetLayersList
     * @summary Returns list of the available layers.
     * @request GET:/layers
     * @response `200` Success
     */
    function getLayersList(query) {
      return this.http.get("/layers", query).json();
    }
    /**
     * No description
     *
     * @tags Layers
     * @name SetPermissionsBatch
     * @operationId LayersController_SetPermissionsBatch
     * @summary Overrides multiply resources permissions in single batch.
     * @request PUT:/layers
     * @response `200` Success
     */

  }, {
    key: "setPermissionsBatch",
    value: function setPermissionsBatch(data) {
      return this.http.put("/layers", data).then(() => {});
    }
    /**
     * No description
     *
     * @tags Layers
     * @name DeleteResources
     * @operationId LayersController_DeleteResources
     * @summary Bulk delete resources.
     * @request DELETE:/layers
     * @response `200` Success
     */

  }, {
    key: "deleteResources",
    value: function deleteResources(query) {
      return this.http.delete("/layers", null, query).json();
    }
    /**
     * No description
     *
     * @tags Layers
     * @name GetLayerInfo
     * @operationId LayersController_GetLayerInfoAsync
     * @summary Returns the layer information.
     * @request GET:/layers/{name}
     * @response `200` Success
     */

  }, {
    key: "getLayerInfo",
    value: function getLayerInfo(name) {
      return this.http.get("/layers/" + name).json();
    }
    /**
     * No description
     *
     * @tags Layers
     * @name DeleteResource
     * @operationId LayersController_DeleteResource
     * @summary Deletes resource.
     * @request DELETE:/layers/{name}
     * @response `200` Success
     */

  }, {
    key: "deleteResource",
    value: function deleteResource(name) {
      return this.http.delete("/layers/" + name, null).then(() => {});
    }
    /**
     * No description
     *
     * @tags Layers
     * @name GetLayersInfo
     * @operationId LayersController_GetLayersInfoAsync
     * @summary Returns the layers information.
     * @request GET:/layers/batchInfo
     * @response `200` Success
     */

  }, {
    key: "getLayersInfo",
    value: function getLayersInfo(query) {
      return this.http.get("/layers/batchInfo", query).json();
    }
    /**
     * No description
     *
     * @tags Layers
     * @name PublishProxyService
     * @operationId LayersController_PublishProxyService
     * @summary Creates new Proxy Service.
     * @request POST:/layers#type=ProxyService
     * @response `default` Error
     */

  }, {
    key: "publishProxyService",
    value: function publishProxyService(data) {
      return this.http.post("/layers", data, {
        type: 'ProxyService'
      }).json();
    }
    /**
     * No description
     *
     * @tags Layers
     * @name PublishRouteService
     * @operationId LayersController_PublishRouteService
     * @summary Creates new Route Service.
     * @request POST:/layers#type=RouteService
     * @response `200` Success
     */

  }, {
    key: "publishRouteService",
    value: function publishRouteService(data) {
      return this.http.post("/layers", data, {
        type: 'RouteService'
      }).then(() => {});
    }
    /**
     * No description
     *
     * @tags Layers
     * @name PublishLinearService
     * @operationId LayersController_PublishLinearService
     * @summary Creates new Linear Service.
     * @request POST:/layers#type=LinearService
     * @response `200` Success
     */

  }, {
    key: "publishLinearService",
    value: function publishLinearService(data) {
      return this.http.post("/layers", data, {
        type: 'LinearService'
      }).then(() => {});
    }
    /**
     * No description
     *
     * @tags Layers
     * @name PublishRemoteTileService
     * @operationId LayersController_PublishRemoteTileService
     * @summary Creates new Remote Tile Service.
     * @request POST:/layers#type=RemoteTileService
     * @response `default` Error
     */

  }, {
    key: "publishRemoteTileService",
    value: function publishRemoteTileService(data) {
      return this.http.post("/layers", data, {
        type: 'RemoteTileService'
      }).json();
    }
    /**
     * No description
     *
     * @tags Layers
     * @name PublishLocalTileService
     * @operationId LayersController_PublishLocalTileService
     * @summary Creates new Local Tile Service.
     * @request POST:/layers#type=LocalTileService
     * @response `default` Error
     */

  }, {
    key: "publishLocalTileService",
    value: function publishLocalTileService(data) {
      return this.http.post("/layers", data, {
        type: 'LocalTileService'
      }).json();
    }
    /**
     * No description
     *
     * @tags Layers
     * @name PublishPostgresLayerService
     * @operationId LayersController_PublishPostgresLayerService
     * @summary Creates new Postgres Layer Service.
     * @request POST:/layers#type=PostgresLayerService
     * @response `default` Error
     */

  }, {
    key: "publishPostgresLayerService",
    value: function publishPostgresLayerService(data) {
      return this.http.post("/layers", data, {
        type: 'PostgresLayerService'
      }).json();
    }
    /**
     * No description
     *
     * @tags Layers
     * @name PublishQueryLayerService
     * @operationId LayersController_PublishQueryLayerService
     * @summary Creates new Postgres Layer Service.
     * @request POST:/layers#type=QueryLayerService
     * @response `default` Error
     */

  }, {
    key: "publishQueryLayerService",
    value: function publishQueryLayerService(data) {
      return this.http.post("/layers", data, {
        type: 'QueryLayerService'
      }).json();
    }
    /**
     * No description
     *
     * @tags Layers
     * @name PublishPostgresTileCatalogService
     * @operationId LayersController_PublishPostgresTileCatalogService
     * @summary Creates new Postgres Tile Catalog Service.
     * @request POST:/layers#type=PostgresTileLayerService
     * @response `default` Error
     */

  }, {
    key: "publishPostgresTileCatalogService",
    value: function publishPostgresTileCatalogService(data) {
      return this.http.post("/layers", data, {
        type: 'PostgresTileLayerService'
      }).json();
    }
    /**
     * No description
     *
     * @tags Layers
     * @name PublishStyledLayerService
     * @operationId LayersController_PublishStyledLayerService
     * @summary Creates new Styled Layer Service.
     * @request POST:/layers#type=StyledFeatureLayer
     * @response `default` Error
     */

  }, {
    key: "publishStyledLayerService",
    value: function publishStyledLayerService(data) {
      return this.http.post("/layers", data, {
        type: 'StyledFeatureLayer'
      }).json();
    }
    /**
     * No description
     *
     * @tags Layers
     * @name UpdateProxyService
     * @operationId LayersController_UpdateProxyService
     * @summary Update Proxy Service.
     * @request PATCH:/layers/{name}#type=ProxyService
     * @response `default` Error
     */

  }, {
    key: "updateProxyService",
    value: function updateProxyService(name, data) {
      return this.http.patch("/layers/" + name, data, {
        type: 'ProxyService'
      }).json();
    }
    /**
     * No description
     *
     * @tags Layers
     * @name UpdateTileCatalogService
     * @operationId LayersController_UpdateTileCatalogService
     * @summary Update Postgres Tile Catalog Service.
     * @request PATCH:/layers/{name}#type=PostgresTileLayerService
     * @response `default` Error
     */

  }, {
    key: "updateTileCatalogService",
    value: function updateTileCatalogService(name, data) {
      return this.http.patch("/layers/" + name, data, {
        type: 'PostgresTileLayerService'
      }).json();
    }
    /**
     * No description
     *
     * @tags Layers
     * @name PublishCompositeService
     * @operationId LayersController_PublishCompositeService
     * @summary Creates new Composite service SPCore.Security.Base.Impl.Services.Composite.CompositeService.
     * @request POST:/layers#type=CompositeService
     * @response `default` Error
     */

  }, {
    key: "publishCompositeService",
    value: function publishCompositeService(data) {
      return this.http.post("/layers", data, {
        type: 'CompositeService'
      }).json();
    }
    /**
     * No description
     *
     * @tags Layers
     * @name UpdateRemoteTileService
     * @operationId LayersController_UpdateRemoteTileService
     * @summary Update Remote Tile Service.
     * @request PATCH:/layers/{name}#type=RemoteTileService
     * @response `default` Error
     */

  }, {
    key: "updateRemoteTileService",
    value: function updateRemoteTileService(name, data) {
      return this.http.patch("/layers/" + name, data, {
        type: 'RemoteTileService'
      }).json();
    }
    /**
     * No description
     *
     * @tags Layers
     * @name UpdateLocalTileService
     * @operationId LayersController_UpdateLocalTileService
     * @summary Update Local Tile Service.
     * @request PATCH:/layers/{name}#type=LocalTileService
     * @response `default` Error
     */

  }, {
    key: "updateLocalTileService",
    value: function updateLocalTileService(name, data) {
      return this.http.patch("/layers/" + name, data, {
        type: 'LocalTileService'
      }).json();
    }
    /**
     * No description
     *
     * @tags Layers
     * @name UpdatePostgresLayerService
     * @operationId LayersController_UpdatePostgresLayerService
     * @summary Update Postgres Layer Service.
     * @request PATCH:/layers/{name}#type=PostgresLayerService
     * @response `default` Error
     */

  }, {
    key: "updatePostgresLayerService",
    value: function updatePostgresLayerService(name, data) {
      return this.http.patch("/layers/" + name, data, {
        type: 'PostgresLayerService'
      }).json();
    }
    /**
     * No description
     *
     * @tags Layers
     * @name UpdateCompositeService
     * @operationId LayersController_UpdateCompositeService
     * @summary Update Composite service SPCore.Security.Base.Impl.Services.Composite.CompositeService.
     * @request PATCH:/layers/{name}#type=CompositeService
     * @response `default` Error
     */

  }, {
    key: "updateCompositeService",
    value: function updateCompositeService(name, data) {
      return this.http.patch("/layers/" + name, data, {
        type: 'CompositeService'
      }).json();
    }
    /**
     * No description
     *
     * @tags Layers
     * @name ReloadService
     * @operationId LayersController_ReloadServiceAsync
     * @summary Initialize a new instance of service by given name.
     * @request GET:/layers/{name}/reload
     * @response `default` Error
     */

  }, {
    key: "reloadService",
    value: function reloadService(name) {
      return this.http.get("/layers/" + name + "/reload").json();
    }
    /**
     * No description
     *
     * @tags Layers
     * @name GetFeatures
     * @operationId LayersController_GetFeatures
     * @summary Returns list of the layer features.
     * @request GET:/layers/{name}/features
     * @response `200` Success
     */

  }, {
    key: "getFeatures",
    value: function getFeatures(_ref) {
      let {
        name
      } = _ref,
          query = _objectWithoutPropertiesLoose(_ref, _excluded$1);

      return this.http.get("/layers/" + name + "/features", query).json();
    }
    /**
     * No description
     *
     * @tags Layers
     * @name DeleteFeature
     * @operationId LayersController_DeleteFeature
     * @summary Deletes feature by id.
     * @request DELETE:/layers/{name}/features
     * @response `200` Success
     */

  }, {
    key: "deleteFeature",
    value: function deleteFeature(_ref2) {
      let {
        name
      } = _ref2,
          query = _objectWithoutPropertiesLoose(_ref2, _excluded2);

      return this.http.delete("/layers/" + name + "/features", null, query).json();
    }
    /**
     * No description
     *
     * @tags Layers
     * @name CreateFeatures
     * @operationId LayersController_CreateFeatures
     * @summary Creates features list of type.SPCore.Connectors.Connectors.Base.Models.Features.FeatureDc.
     * @request POST:/layers/{name}/features
     * @response `200` Success
     */

  }, {
    key: "createFeatures",
    value: function createFeatures(name, data) {
      return this.http.post("/layers/" + name + "/features", data).json();
    }
    /**
     * No description
     *
     * @tags Layers
     * @name UpdateFeature
     * @operationId LayersController_UpdateFeature
     * @summary Updates features list SPCore.Connectors.Connectors.Base.Models.Features.FeatureDc.
     * @request PATCH:/layers/{name}/features
     * @response `200` Success
     */

  }, {
    key: "updateFeature",
    value: function updateFeature(name, data) {
      return this.http.patch("/layers/" + name + "/features", data).json();
    }
    /**
     * No description
     *
     * @tags Layers
     * @name FeaturesContains
     * @operationId LayersController_FeaturesContains
     * @summary Gets filtered features with given filter.
     * @request GET:/layers/{name}/features/contains
     * @response `200` Success
     */

  }, {
    key: "featuresContains",
    value: function featuresContains(_ref3) {
      let {
        name
      } = _ref3,
          query = _objectWithoutPropertiesLoose(_ref3, _excluded3);

      return this.http.get("/layers/" + name + "/features/contains", query).json();
    }
    /**
     * No description
     *
     * @tags Layers
     * @name GetById
     * @operationId LayersController_GetByIdAsync
     * @summary Gets feature by id.
     * @request GET:/layers/{name}/features/{id}
     * @response `200` Success
     */

  }, {
    key: "getById",
    value: function getById(_ref4) {
      let {
        name,
        id
      } = _ref4,
          query = _objectWithoutPropertiesLoose(_ref4, _excluded4);

      return this.http.get("/layers/" + name + "/features/" + id, query).json();
    }
    /**
     * No description
     *
     * @tags Layers
     * @name Unite
     * @operationId LayersController_Unite
     * @summary Provides method to unite feature geometry with given id and given geometry. Updated feature will be save in db storage. Result of the operation will be updated layer info.
     * @request POST:/layers/{name}/features/{id}/unite
     * @response `200` Success
     */

  }, {
    key: "unite",
    value: function unite(_ref5, data) {
      let {
        name,
        id
      } = _ref5,
          query = _objectWithoutPropertiesLoose(_ref5, _excluded5);

      return this.http.post("/layers/" + name + "/features/" + id + "/unite", data, query).json();
    }
    /**
     * No description
     *
     * @tags Layers
     * @name Subtract
     * @operationId LayersController_Subtract
     * @summary Provides method to subtract feature geometry with given id and given geometry. Updated feature will be save in db storage. Result of the operation will be updated layer info with feature id.
     * @request POST:/layers/{name}/features/{id}/subtract
     * @response `200` Success
     */

  }, {
    key: "subtract",
    value: function subtract(_ref6, data) {
      let {
        name,
        id
      } = _ref6,
          query = _objectWithoutPropertiesLoose(_ref6, _excluded6);

      return this.http.post("/layers/" + name + "/features/" + id + "/subtract", data, query).json();
    }
    /**
     * No description
     *
     * @tags Layers
     * @name GetTilesLayerImage
     * @operationId LayersController_GetTilesLayerImage
     * @summary Render tile with input indexes.
     * @request GET:/layers/{name}/tile/{z}/{x}/{y}
     * @response `200` Success
     */

  }, {
    key: "getTilesLayerImage",
    value: function getTilesLayerImage(_ref7) {
      let {
        name,
        x,
        y,
        z
      } = _ref7,
          query = _objectWithoutPropertiesLoose(_ref7, _excluded7);

      return this.http.createUrl("/layers/" + name + "/tile/" + z + "/" + x + "/" + y, query);
    }
    /**
     * No description
     *
     * @tags Layers
     * @name GetLayerImage
     * @operationId LayersController_GetLayerImage
     * @summary Renders the layer to the image of the requested size.
     * @request GET:/layers/{name}/export
     * @response `200` Success
     */

  }, {
    key: "getLayerImage",
    value: function getLayerImage(_ref8) {
      let {
        name
      } = _ref8,
          query = _objectWithoutPropertiesLoose(_ref8, _excluded8);

      return this.http.createUrl("/layers/" + name + "/export", query);
    }
    /**
     * No description
     *
     * @tags Layers
     * @name GetLayerExtent
     * @operationId LayersController_GetLayerExtent
     * @summary Returns the extent of the layer.
     * @request GET:/layers/{name}/extent
     * @response `200` Success
     */

  }, {
    key: "getLayerExtent",
    value: function getLayerExtent(_ref9) {
      let {
        name
      } = _ref9,
          query = _objectWithoutPropertiesLoose(_ref9, _excluded9);

      return this.http.get("/layers/" + name + "/extent", query).json();
    }
    /**
     * No description
     *
     * @tags Layers
     * @name GetByGeometry
     * @operationId LayersController_GetByGeometryAsync
     * @summary Gets the features within the given geometry.
     * @request GET:/layers/{name}/features/getByGeometry
     * @response `200` Success
     */

  }, {
    key: "getByGeometry",
    value: function getByGeometry(_ref10) {
      let {
        name
      } = _ref10,
          query = _objectWithoutPropertiesLoose(_ref10, _excluded10);

      return this.http.get("/layers/" + name + "/features/getByGeometry", query).json();
    }
    /**
     * No description
     *
     * @tags Layers
     * @name GetByGeometryPost
     * @operationId LayersController_GetByGeometryAsync_1
     * @summary Gets the features within the given geometry.
     * @request POST:/layers/{name}/features/getByGeometry
     * @response `200` Success
     */

  }, {
    key: "getByGeometryPost",
    value: function getByGeometryPost(_ref11, data) {
      let {
        name
      } = _ref11,
          query = _objectWithoutPropertiesLoose(_ref11, _excluded11);

      return this.http.post("/layers/" + name + "/features/getByGeometry", data, query).json();
    }
    /**
     * No description
     *
     * @tags Layers
     * @name DeleteFeatures
     * @operationId LayersController_DeleteFeatures
     * @summary Delete a list of features by given ids. Example: ids=1,2,3.
     * @request DELETE:/layers/{name}/features/deleteByIds
     * @response `200` Success
     */

  }, {
    key: "deleteFeatures",
    value: function deleteFeatures(_ref12) {
      let {
        name
      } = _ref12,
          query = _objectWithoutPropertiesLoose(_ref12, _excluded12);

      return this.http.delete("/layers/" + name + "/features/deleteByIds", null, query).json();
    }
    /**
     * No description
     *
     * @tags Layers
     * @name DeleteByCondition
     * @operationId LayersController_DeleteByCondition
     * @summary Delete a list of features by condition with exclude given ids.
     * @request DELETE:/layers/{name}/features/deleteByCondition
     * @response `200` Success
     */

  }, {
    key: "deleteByCondition",
    value: function deleteByCondition(_ref13) {
      let {
        name
      } = _ref13,
          query = _objectWithoutPropertiesLoose(_ref13, _excluded13);

      return this.http.delete("/layers/" + name + "/features/deleteByCondition", null, query).json();
    }
    /**
     * No description
     *
     * @tags Layers
     * @name GetByGeometryGet
     * @operationId LayersController_GetByGeometryAsync_2
     * @summary Gets the features by click position.
     * @request GET:/layers/{name}/features/getByGeometryByClick
     * @response `200` Success
     */

  }, {
    key: "getByGeometryGet",
    value: function getByGeometryGet(_ref14) {
      let {
        name
      } = _ref14,
          query = _objectWithoutPropertiesLoose(_ref14, _excluded14);

      return this.http.get("/layers/" + name + "/features/getByGeometryByClick", query).json();
    }
    /**
     * No description
     *
     * @tags Layers
     * @name Classify
     * @operationId LayersController_Classify
     * @summary Returns the classified attribute values that correspond to the given number of classes.
     * @request GET:/layers/{name}/classify
     * @response `200` Success
     */

  }, {
    key: "classify",
    value: function classify(_ref15) {
      let {
        name
      } = _ref15,
          query = _objectWithoutPropertiesLoose(_ref15, _excluded15);

      return this.http.get("/layers/" + name + "/classify", query).json();
    }
    /**
     * No description
     *
     * @tags Layers
     * @name Distincts
     * @operationId LayersController_Distincts
     * @summary Returns distinct attribute values and their count.
     * @request GET:/layers/{name}/distincts
     * @response `200` Success
     */

  }, {
    key: "distincts",
    value: function distincts(_ref16) {
      let {
        name
      } = _ref16,
          query = _objectWithoutPropertiesLoose(_ref16, _excluded16);

      return this.http.get("/layers/" + name + "/distincts", query).json();
    }
    /**
     * No description
     *
     * @tags Layers
     * @name AggregateAttribute
     * @operationId LayersController_AggregateAttribute
     * @summary Returns aggregated value of given attribute aggregationAttributeName within a given groups groups.
     * @request GET:/layers/{name}/aggregate-values
     * @response `200` Success
     */

  }, {
    key: "aggregateAttribute",
    value: function aggregateAttribute(_ref17) {
      let {
        name
      } = _ref17,
          query = _objectWithoutPropertiesLoose(_ref17, _excluded17);

      return this.http.get("/layers/" + name + "/aggregate-values", query).json();
    }
    /**
     * No description
     *
     * @tags Layers
     * @name GetFilteredFeaturesCount
     * @operationId LayersController_GetFilteredFeaturesCount
     * @summary Get features count according layer filter of the given name.
     * @request GET:/layers/{name}/features/count
     * @response `200` Success
     */

  }, {
    key: "getFilteredFeaturesCount",
    value: function getFilteredFeaturesCount(_ref18) {
      let {
        name
      } = _ref18,
          query = _objectWithoutPropertiesLoose(_ref18, _excluded18);

      return this.http.get("/layers/" + name + "/features/count", query).json();
    }
    /**
     * No description
     *
     * @tags Layers
     * @name EditAttributes
     * @operationId LayersController_EditAttributes
     * @summary Edit attributes with editInfo.
     * @request POST:/layers/{name}/features/edit-attributes
     * @response `200` Success
     */

  }, {
    key: "editAttributes",
    value: function editAttributes(name, data) {
      return this.http.post("/layers/" + name + "/features/edit-attributes", data).json();
    }
    /**
     * No description
     *
     * @tags Layers
     * @name SelectFeatures
     * @operationId LayersController_SelectFeatures
     * @summary Selects features from the given layers by the visual point on the map.
     * @request GET:/layers/features/select
     * @response `200` Success
     */

  }, {
    key: "selectFeatures",
    value: function selectFeatures(query) {
      return this.http.get("/layers/features/select", query).json();
    }
    /**
     * No description
     *
     * @tags Layers
     * @name ValidateExpression
     * @operationId LayersController_ValidateExpression
     * @summary Validates the given EQL expression against the requested layer. If the expression is valid, it can be executed on the features in the layer to produce a value of some type. The type of the resulting value will be also returned in the validation result.
     * @request GET:/layers/{layerName}/validateExpression
     * @response `200` Success
     * @response `400` Bad Request
     */

  }, {
    key: "validateExpression",
    value: function validateExpression(_ref19) {
      let {
        layerName
      } = _ref19,
          query = _objectWithoutPropertiesLoose(_ref19, _excluded19);

      return this.http.get("/layers/" + layerName + "/validateExpression", query).json();
    }
    /**
     * No description
     *
     * @tags Layers
     * @name GetRasterMeta
     * @operationId LayersController_GetRasterMeta
     * @summary Get raster metadata.
     * @request GET:/layers/{name}/{id}/metadata
     * @response `200` Success
     */

  }, {
    key: "getRasterMeta",
    value: function getRasterMeta(_ref20) {
      let {
        name,
        id
      } = _ref20,
          query = _objectWithoutPropertiesLoose(_ref20, _excluded20);

      return this.http.get("/layers/" + name + "/" + id + "/metadata", query).json();
    }
    /**
     * No description
     *
     * @tags Layers
     * @name CreateRoute
     * @operationId LayersController_CreateRoute
     * @summary Create new route (feature) from source features.
     * @request POST:/layers/{name}/createRoute
     * @response `200` Success
     */

  }, {
    key: "createRoute",
    value: function createRoute(name, data) {
      return this.http.post("/layers/" + name + "/createRoute", data).json();
    }
    /**
     * No description
     *
     * @tags Layers
     * @name GetPreview
     * @operationId LayersController_GetPreview
     * @summary Gets preview of resource.
     * @request GET:/layers/{name}/preview
     * @response `200` Success
     */

  }, {
    key: "getPreview",
    value: function getPreview(name) {
      return this.http.createUrl("/layers/" + name + "/preview");
    }
    /**
     * No description
     *
     * @tags Layers
     * @name SetPreview
     * @operationId LayersController_SetPreview
     * @summary Sets preview to the resource.
     * @request POST:/layers/{name}/preview
     * @response `200` Success
     */

  }, {
    key: "setPreview",
    value: function setPreview(name, data) {
      return this.http.post("/layers/" + name + "/preview", toFormData(data)).json();
    }
    /**
     * No description
     *
     * @tags Layers
     * @name DeletePreview
     * @operationId LayersController_DeletePreview
     * @summary Delete resource preview.
     * @request DELETE:/layers/{name}/preview
     * @response `200` Success
     */

  }, {
    key: "deletePreview",
    value: function deletePreview(name) {
      return this.http.delete("/layers/" + name + "/preview", null).then(() => {});
    }
    /**
     * No description
     *
     * @tags Layers
     * @name IsExists
     * @operationId LayersController_IsExistsAsync
     * @summary Check is resource exists.
     * @request GET:/layers/{name}/exists
     * @response `200` Success
     */

  }, {
    key: "isExists",
    value: function isExists(name) {
      return this.http.get("/layers/" + name + "/exists").then(() => {});
    }
    /**
     * No description
     *
     * @tags Layers
     * @name GetResourceDependencies
     * @operationId LayersController_GetResourceDependencies
     * @summary Get resource dependencies.
     * @request GET:/layers/{name}/dependencies
     * @response `200` Success
     */

  }, {
    key: "getResourceDependencies",
    value: function getResourceDependencies(name) {
      return this.http.get("/layers/" + name + "/dependencies").json();
    }
    /**
     * No description
     *
     * @tags Layers
     * @name GetResourceReferences
     * @operationId LayersController_GetResourceReferences
     * @summary Returns the resource dependency information.
     * @request GET:/layers/{name}/references
     * @response `200` Success
     */

  }, {
    key: "getResourceReferences",
    value: function getResourceReferences(name) {
      return this.http.get("/layers/" + name + "/references").json();
    }
    /**
     * No description
     *
     * @tags Layers
     * @name GetPermissions
     * @operationId LayersController_GetPermissions
     * @summary Returns resource permissions.
     * @request GET:/layers/{name}/permissions
     * @response `200` Success
     */

  }, {
    key: "getPermissions",
    value: function getPermissions(name) {
      return this.http.get("/layers/" + name + "/permissions").json();
    }
    /**
     * No description
     *
     * @tags Layers
     * @name AddPermissions
     * @operationId LayersController_AddPermissions
     * @summary Adds permissions for the layer, combining existing permissions with the given one.
     * @request POST:/layers/{name}/permissions
     * @response `200` Success
     */

  }, {
    key: "addPermissions",
    value: function addPermissions(name, data) {
      return this.http.post("/layers/" + name + "/permissions", data).json();
    }
    /**
     * No description
     *
     * @tags Layers
     * @name SetPermissions
     * @operationId LayersController_SetPermissions
     * @summary Replaces existing access control list for the layer with the given one.
     * @request PUT:/layers/{name}/permissions
     * @response `200` Success
     */

  }, {
    key: "setPermissions",
    value: function setPermissions(name, data) {
      return this.http.put("/layers/" + name + "/permissions", data).json();
    }
    /**
     * No description
     *
     * @tags Layers
     * @name RemovePermissions
     * @operationId LayersController_RemovePermissions
     * @summary Removes permissions for the layer for the given role.
     * @request DELETE:/layers/{name}/permissions/{role}
     * @response `200` Success
     */

  }, {
    key: "removePermissions",
    value: function removePermissions(name, role) {
      return this.http.delete("/layers/" + name + "/permissions/" + role, null).json();
    }
  }]);

  return LayersService;
}(Service);

async function promiseAllIgnoreErrors(promises) {
  const results = await Promise.all(promises.map(promise => promise.catch(e => isError(e) ? e : new Error(e))));
  return results.filter(notError);
}

function isError(v) {
  return v instanceof Error;
}

function notError(v) {
  return !isError(v);
}

const _excluded$2 = ["remote"];
let Layers = /*#__PURE__*/function (_LayersService) {
  _inherits(Layers, _LayersService);

  var _super = /*#__PURE__*/_createSuper(Layers);

  function Layers() {
    _classCallCheck(this, Layers);

    return _super.apply(this, arguments);
  }

  _createClass(Layers, [{
    key: "getLayerInfos",
    value: function getLayerInfos(layers) {
      return promiseAllIgnoreErrors(layers.map(layer => this.getLayerInfo(layer)));
    }
  }, {
    key: "getLayersDeps",
    value: function getLayersDeps(layers) {
      return promiseAllIgnoreErrors(layers.map(layer => this.getResourceDependencies(layer)));
    }
  }, {
    key: "getBasemaps",
    value: function getBasemaps(params) {
      return this.getLayersList(_extends({}, params, {
        types: ['LocalTileService', 'RemoteTileService']
      }));
    }
  }, {
    key: "createSubLayer",
    value: function createSubLayer(configuration) {
      return this.publishStyledLayerService(configuration);
    }
  }, {
    key: "createTileLayer",
    value: function createTileLayer(_ref) {
      let {
        remote
      } = _ref,
          configuration = _objectWithoutPropertiesLoose(_ref, _excluded$2);

      if (remote) {
        return this.publishRemoteTileService(configuration);
      }

      return this.publishLocalTileService(configuration);
    }
  }, {
    key: "uploadPreview",
    value: function uploadPreview(name, file) {
      return this.setPreview(name, {
        file
      });
    }
  }, {
    key: "findOne",
    value: function findOne(name) {
      return this.getLayerInfo(name);
    }
  }, {
    key: "findAll",
    value: function findAll(params) {
      return this.getLayersList(params);
    }
  }, {
    key: "create",
    value: function create(configuration) {
      return this.publishPostgresLayerService(configuration);
    }
  }, {
    key: "update",
    value: function update(configuration) {
      return this.updatePostgresLayerService(configuration.name, configuration);
    }
  }, {
    key: "remove",
    value: async function remove(name) {
      await this.deleteResource(name);
      return name;
    }
  }]);

  return Layers;
}(LayersService);
function isTileLayerService(layer) {
  return layer.type && /TileService/.test(layer.type);
}

const _excluded$3 = ["name"],
      _excluded2$1 = ["name"],
      _excluded3$1 = ["name"],
      _excluded4$1 = ["name"];
/**
 * @title Spatial Processing Core API
 * @version 1.0.0
 * @baseUrl /sp
 */

let TablesService = /*#__PURE__*/function (_Service) {
  _inherits(TablesService, _Service);

  var _super = /*#__PURE__*/_createSuper(TablesService);

  function TablesService() {
    _classCallCheck(this, TablesService);

    return _super.apply(this, arguments);
  }

  _createClass(TablesService, [{
    key: "getTableList",
    value:
    /**
     * No description
     *
     * @tags Tables
     * @name GetTableList
     * @operationId TablesController_GetTableList
     * @summary Returns the list of tables in data service.
     * @request GET:/tables
     * @response `200` Success
     */
    function getTableList(query) {
      return this.http.get("/tables", query).json();
    }
    /**
     * No description
     *
     * @tags Tables
     * @name CreateTable
     * @operationId TablesController_CreateTable
     * @summary Creates a new table.
     * @request POST:/tables
     * @response `200` Success
     */

  }, {
    key: "createTable",
    value: function createTable(data) {
      return this.http.post("/tables", data).json();
    }
    /**
     * No description
     *
     * @tags Tables
     * @name SetPermissionsBatch
     * @operationId TablesController_SetPermissionsBatch
     * @summary Overrides multiply resources permissions in single batch.
     * @request PUT:/tables
     * @response `200` Success
     */

  }, {
    key: "setPermissionsBatch",
    value: function setPermissionsBatch(data) {
      return this.http.put("/tables", data).then(() => {});
    }
    /**
     * No description
     *
     * @tags Tables
     * @name DeleteResources
     * @operationId TablesController_DeleteResources
     * @summary Bulk delete resources.
     * @request DELETE:/tables
     * @response `200` Success
     */

  }, {
    key: "deleteResources",
    value: function deleteResources(query) {
      return this.http.delete("/tables", null, query).json();
    }
    /**
     * No description
     *
     * @tags Tables
     * @name UpdateTable
     * @operationId TablesController_UpdateTable
     * @summary Update exists table.
     * @request PATCH:/tables/{name}
     * @response `200` Success
     */

  }, {
    key: "updateTable",
    value: function updateTable(name, data) {
      return this.http.patch("/tables/" + name, data).json();
    }
    /**
     * No description
     *
     * @tags Tables
     * @name PutTable
     * @operationId TablesController_PutTable
     * @summary Override exists table.
     * @request PUT:/tables/{name}
     * @response `200` Success
     */

  }, {
    key: "putTable",
    value: function putTable(name, data) {
      return this.http.put("/tables/" + name, data).json();
    }
    /**
     * No description
     *
     * @tags Tables
     * @name GetTableInfo
     * @operationId TablesController_GetTableInfo
     * @summary Returns the table information and schema.
     * @request GET:/tables/{name}
     * @response `200` Success
     */

  }, {
    key: "getTableInfo",
    value: function getTableInfo(name) {
      return this.http.get("/tables/" + name).json();
    }
    /**
     * No description
     *
     * @tags Tables
     * @name DeleteResource
     * @operationId TablesController_DeleteResource
     * @summary Deletes resource.
     * @request DELETE:/tables/{name}
     * @response `200` Success
     */

  }, {
    key: "deleteResource",
    value: function deleteResource(name) {
      return this.http.delete("/tables/" + name, null).then(() => {});
    }
    /**
     * No description
     *
     * @tags Tables
     * @name GetTablesInfo
     * @operationId TablesController_GetTablesInfoAsync
     * @summary Returns the tables information.
     * @request GET:/tables/batchInfo
     * @response `200` Success
     */

  }, {
    key: "getTablesInfo",
    value: function getTablesInfo(query) {
      return this.http.get("/tables/batchInfo", query).json();
    }
    /**
     * No description
     *
     * @tags Tables
     * @name GetTableData
     * @operationId TablesController_GetTableData
     * @summary Retrieves the data from the table.
     * @request GET:/tables/{name}/data
     * @response `200` Success
     */

  }, {
    key: "getTableData",
    value: function getTableData(_ref) {
      let {
        name
      } = _ref,
          query = _objectWithoutPropertiesLoose(_ref, _excluded$3);

      return this.http.get("/tables/" + name + "/data", query).json();
    }
    /**
     * No description
     *
     * @tags Tables
     * @name WriteTableData
     * @operationId TablesController_WriteTableData
     * @summary Adds the data to the table.
     * @request POST:/tables/{name}/data
     * @response `200` Success
     */

  }, {
    key: "writeTableData",
    value: function writeTableData(name, data) {
      return this.http.post("/tables/" + name + "/data", data).then(() => {});
    }
    /**
     * No description
     *
     * @tags Tables
     * @name UpdateTableData
     * @operationId TablesController_UpdateTableData
     * @summary Updates the data in the table.
     * @request PATCH:/tables/{name}/data
     * @response `200` Success
     */

  }, {
    key: "updateTableData",
    value: function updateTableData(_ref2, data) {
      let {
        name
      } = _ref2,
          query = _objectWithoutPropertiesLoose(_ref2, _excluded2$1);

      return this.http.patch("/tables/" + name + "/data", data, query).then(() => {});
    }
    /**
     * No description
     *
     * @tags Tables
     * @name DeleteTableData
     * @operationId TablesController_DeleteTableData
     * @summary Delete data rows from the table.
     * @request DELETE:/tables/{name}/data
     * @response `200` Success
     */

  }, {
    key: "deleteTableData",
    value: function deleteTableData(_ref3) {
      let {
        name
      } = _ref3,
          query = _objectWithoutPropertiesLoose(_ref3, _excluded3$1);

      return this.http.delete("/tables/" + name + "/data", null, query).then(() => {});
    }
    /**
     * No description
     *
     * @tags Tables
     * @name GetUniqueDataRows
     * @operationId TablesController_GetUniqueDataRowsAsync
     * @summary Returns a single data row for each unique value defined by uniqueColumn.
     * @request GET:/tables/{name}/data/unique-values
     * @response `200` Success
     */

  }, {
    key: "getUniqueDataRows",
    value: function getUniqueDataRows(_ref4) {
      let {
        name
      } = _ref4,
          query = _objectWithoutPropertiesLoose(_ref4, _excluded4$1);

      return this.http.get("/tables/" + name + "/data/unique-values", query).json();
    }
    /**
     * No description
     *
     * @tags Tables
     * @name MapTable
     * @operationId TablesController_MapTable
     * @summary Map table to exists table.
     * @request POST:/tables/map-table
     * @response `200` Success
     */

  }, {
    key: "mapTable",
    value: function mapTable(query, data) {
      return this.http.post("/tables/map-table", data, query).json();
    }
    /**
     * No description
     *
     * @tags Tables
     * @name UnmapTable
     * @operationId TablesController_UnmapTableAsync
     * @summary Unmap datasource from table.
     * @request DELETE:/tables/map-table/{name}
     * @response `200` Success
     */

  }, {
    key: "unmapTable",
    value: function unmapTable(name) {
      return this.http.delete("/tables/map-table/" + name, null).then(() => {});
    }
    /**
     * No description
     *
     * @tags Tables
     * @name GetPreview
     * @operationId TablesController_GetPreview
     * @summary Gets preview of resource.
     * @request GET:/tables/{name}/preview
     * @response `200` Success
     */

  }, {
    key: "getPreview",
    value: function getPreview(name) {
      return this.http.createUrl("/tables/" + name + "/preview");
    }
    /**
     * No description
     *
     * @tags Tables
     * @name SetPreview
     * @operationId TablesController_SetPreview
     * @summary Sets preview to the resource.
     * @request POST:/tables/{name}/preview
     * @response `200` Success
     */

  }, {
    key: "setPreview",
    value: function setPreview(name, data) {
      return this.http.post("/tables/" + name + "/preview", toFormData(data)).json();
    }
    /**
     * No description
     *
     * @tags Tables
     * @name DeletePreview
     * @operationId TablesController_DeletePreview
     * @summary Delete resource preview.
     * @request DELETE:/tables/{name}/preview
     * @response `200` Success
     */

  }, {
    key: "deletePreview",
    value: function deletePreview(name) {
      return this.http.delete("/tables/" + name + "/preview", null).then(() => {});
    }
    /**
     * No description
     *
     * @tags Tables
     * @name IsExists
     * @operationId TablesController_IsExistsAsync
     * @summary Check is resource exists.
     * @request GET:/tables/{name}/exists
     * @response `200` Success
     */

  }, {
    key: "isExists",
    value: function isExists(name) {
      return this.http.get("/tables/" + name + "/exists").then(() => {});
    }
    /**
     * No description
     *
     * @tags Tables
     * @name GetResourceDependencies
     * @operationId TablesController_GetResourceDependencies
     * @summary Get resource dependencies.
     * @request GET:/tables/{name}/dependencies
     * @response `200` Success
     */

  }, {
    key: "getResourceDependencies",
    value: function getResourceDependencies(name) {
      return this.http.get("/tables/" + name + "/dependencies").json();
    }
    /**
     * No description
     *
     * @tags Tables
     * @name GetResourceReferences
     * @operationId TablesController_GetResourceReferences
     * @summary Returns the resource dependency information.
     * @request GET:/tables/{name}/references
     * @response `200` Success
     */

  }, {
    key: "getResourceReferences",
    value: function getResourceReferences(name) {
      return this.http.get("/tables/" + name + "/references").json();
    }
    /**
     * No description
     *
     * @tags Tables
     * @name GetPermissions
     * @operationId TablesController_GetPermissions
     * @summary Returns resource permissions.
     * @request GET:/tables/{name}/permissions
     * @response `200` Success
     */

  }, {
    key: "getPermissions",
    value: function getPermissions(name) {
      return this.http.get("/tables/" + name + "/permissions").json();
    }
    /**
     * No description
     *
     * @tags Tables
     * @name AddPermissions
     * @operationId TablesController_AddPermissions
     * @summary Adds permissions for the layer, combining existing permissions with the given one.
     * @request POST:/tables/{name}/permissions
     * @response `200` Success
     */

  }, {
    key: "addPermissions",
    value: function addPermissions(name, data) {
      return this.http.post("/tables/" + name + "/permissions", data).json();
    }
    /**
     * No description
     *
     * @tags Tables
     * @name SetPermissions
     * @operationId TablesController_SetPermissions
     * @summary Replaces existing access control list for the layer with the given one.
     * @request PUT:/tables/{name}/permissions
     * @response `200` Success
     */

  }, {
    key: "setPermissions",
    value: function setPermissions(name, data) {
      return this.http.put("/tables/" + name + "/permissions", data).json();
    }
    /**
     * No description
     *
     * @tags Tables
     * @name RemovePermissions
     * @operationId TablesController_RemovePermissions
     * @summary Removes permissions for the layer for the given role.
     * @request DELETE:/tables/{name}/permissions/{role}
     * @response `200` Success
     */

  }, {
    key: "removePermissions",
    value: function removePermissions(name, role) {
      return this.http.delete("/tables/" + name + "/permissions/" + role, null).json();
    }
  }]);

  return TablesService;
}(Service);

let Tables = /*#__PURE__*/function (_TablesService) {
  _inherits(Tables, _TablesService);

  var _super = /*#__PURE__*/_createSuper(Tables);

  function Tables() {
    _classCallCheck(this, Tables);

    return _super.apply(this, arguments);
  }

  _createClass(Tables, [{
    key: "getTableInfos",
    value: function getTableInfos(tables) {
      return promiseAllIgnoreErrors(tables.map(table => this.getTableInfo(table)));
    }
  }, {
    key: "uploadPreview",
    value: function uploadPreview(name, file) {
      return this.setPreview(name, {
        file
      });
    }
  }, {
    key: "findOne",
    value: function findOne(name) {
      return this.getTableInfo(name);
    }
  }, {
    key: "findAll",
    value: function findAll(params) {
      return this.getTableList(params);
    }
  }, {
    key: "create",
    value: function create(resource) {
      return this.createTable(resource);
    }
  }, {
    key: "update",
    value: function update(table) {
      return this.updateTable(table.name, table);
    }
  }, {
    key: "remove",
    value: async function remove(name) {
      await this.deleteResource(name);
      return name;
    }
  }]);

  return Tables;
}(TablesService);

/**
 * @title Spatial Processing Core API
 * @version 1.0.0
 * @baseUrl /sp
 */

let ProjectsService = /*#__PURE__*/function (_Service) {
  _inherits(ProjectsService, _Service);

  var _super = /*#__PURE__*/_createSuper(ProjectsService);

  function ProjectsService() {
    _classCallCheck(this, ProjectsService);

    return _super.apply(this, arguments);
  }

  _createClass(ProjectsService, [{
    key: "getProjectsList",
    value:
    /**
     * No description
     *
     * @tags Projects
     * @name GetProjectsList
     * @operationId ProjectsController_GetProjectsList
     * @summary Returns the list of projects.
     * @request GET:/projects
     * @response `200` Success
     */
    function getProjectsList(query) {
      return this.http.get("/projects", query).json();
    }
    /**
     * No description
     *
     * @tags Projects
     * @name CreateProject
     * @operationId ProjectsController_CreateProject
     * @summary Creates a new project.
     * @request POST:/projects
     * @response `200` Success
     */

  }, {
    key: "createProject",
    value: function createProject(data) {
      return this.http.post("/projects", data).json();
    }
    /**
     * No description
     *
     * @tags Projects
     * @name SetPermissionsBatch
     * @operationId ProjectsController_SetPermissionsBatch
     * @summary Overrides multiply resources permissions in single batch.
     * @request PUT:/projects
     * @response `200` Success
     */

  }, {
    key: "setPermissionsBatch",
    value: function setPermissionsBatch(data) {
      return this.http.put("/projects", data).then(() => {});
    }
    /**
     * No description
     *
     * @tags Projects
     * @name DeleteResources
     * @operationId ProjectsController_DeleteResources
     * @summary Bulk delete resources.
     * @request DELETE:/projects
     * @response `200` Success
     */

  }, {
    key: "deleteResources",
    value: function deleteResources(query) {
      return this.http.delete("/projects", null, query).json();
    }
    /**
     * No description
     *
     * @tags Projects
     * @name UpdateProject
     * @operationId ProjectsController_UpdateProject
     * @summary Update table.
     * @request PATCH:/projects/{name}
     * @response `200` Success
     */

  }, {
    key: "updateProject",
    value: function updateProject(name, data) {
      return this.http.patch("/projects/" + name, data).json();
    }
    /**
     * No description
     *
     * @tags Projects
     * @name GetProjectInfo
     * @operationId ProjectsController_GetProjectInfo
     * @summary Returns the project and it's content information.
     * @request GET:/projects/{name}
     * @response `200` Success
     */

  }, {
    key: "getProjectInfo",
    value: function getProjectInfo(name) {
      return this.http.get("/projects/" + name).json();
    }
    /**
     * No description
     *
     * @tags Projects
     * @name DeleteResource
     * @operationId ProjectsController_DeleteResource
     * @summary Deletes resource.
     * @request DELETE:/projects/{name}
     * @response `200` Success
     */

  }, {
    key: "deleteResource",
    value: function deleteResource(name) {
      return this.http.delete("/projects/" + name, null).then(() => {});
    }
    /**
     * No description
     *
     * @tags Projects
     * @name GetProjectsInfo
     * @operationId ProjectsController_GetProjectsInfoAsync
     * @summary Returns the projects information.
     * @request GET:/projects/batchInfo
     * @response `200` Success
     */

  }, {
    key: "getProjectsInfo",
    value: function getProjectsInfo(query) {
      return this.http.get("/projects/batchInfo", query).json();
    }
    /**
     * No description
     *
     * @tags Projects
     * @name GetProjectLayersExtendedInfo
     * @operationId ProjectsController_GetProjectLayersExtendedInfo
     * @summary Gets extended project info with layers info.
     * @request GET:/projects/{name}/extended-info
     * @response `200` Success
     */

  }, {
    key: "getProjectLayersExtendedInfo",
    value: function getProjectLayersExtendedInfo(name) {
      return this.http.get("/projects/" + name + "/extended-info").json();
    }
    /**
     * No description
     *
     * @tags Projects
     * @name GetTilesLayerImage
     * @operationId ProjectsController_GetTilesLayerImage
     * @summary Render tile.
     * @request GET:/projects/{name}/tile/{z}/{x}/{y}
     * @response `200` Success
     */

  }, {
    key: "getTilesLayerImage",
    value: function getTilesLayerImage(name, x, y, z) {
      return this.http.createUrl("/projects/" + name + "/tile/" + z + "/" + x + "/" + y);
    }
    /**
     * No description
     *
     * @tags Projects
     * @name GetPreview
     * @operationId ProjectsController_GetPreview
     * @summary Gets preview of resource.
     * @request GET:/projects/{name}/preview
     * @response `200` Success
     */

  }, {
    key: "getPreview",
    value: function getPreview(name) {
      return this.http.createUrl("/projects/" + name + "/preview");
    }
    /**
     * No description
     *
     * @tags Projects
     * @name SetPreview
     * @operationId ProjectsController_SetPreview
     * @summary Sets preview to the resource.
     * @request POST:/projects/{name}/preview
     * @response `200` Success
     */

  }, {
    key: "setPreview",
    value: function setPreview(name, data) {
      return this.http.post("/projects/" + name + "/preview", toFormData(data)).json();
    }
    /**
     * No description
     *
     * @tags Projects
     * @name DeletePreview
     * @operationId ProjectsController_DeletePreview
     * @summary Delete resource preview.
     * @request DELETE:/projects/{name}/preview
     * @response `200` Success
     */

  }, {
    key: "deletePreview",
    value: function deletePreview(name) {
      return this.http.delete("/projects/" + name + "/preview", null).then(() => {});
    }
    /**
     * No description
     *
     * @tags Projects
     * @name IsExists
     * @operationId ProjectsController_IsExistsAsync
     * @summary Check is resource exists.
     * @request GET:/projects/{name}/exists
     * @response `200` Success
     */

  }, {
    key: "isExists",
    value: function isExists(name) {
      return this.http.get("/projects/" + name + "/exists").then(() => {});
    }
    /**
     * No description
     *
     * @tags Projects
     * @name GetResourceDependencies
     * @operationId ProjectsController_GetResourceDependencies
     * @summary Get resource dependencies.
     * @request GET:/projects/{name}/dependencies
     * @response `200` Success
     */

  }, {
    key: "getResourceDependencies",
    value: function getResourceDependencies(name) {
      return this.http.get("/projects/" + name + "/dependencies").json();
    }
    /**
     * No description
     *
     * @tags Projects
     * @name GetResourceReferences
     * @operationId ProjectsController_GetResourceReferences
     * @summary Returns the resource dependency information.
     * @request GET:/projects/{name}/references
     * @response `200` Success
     */

  }, {
    key: "getResourceReferences",
    value: function getResourceReferences(name) {
      return this.http.get("/projects/" + name + "/references").json();
    }
    /**
     * No description
     *
     * @tags Projects
     * @name GetPermissions
     * @operationId ProjectsController_GetPermissions
     * @summary Returns resource permissions.
     * @request GET:/projects/{name}/permissions
     * @response `200` Success
     */

  }, {
    key: "getPermissions",
    value: function getPermissions(name) {
      return this.http.get("/projects/" + name + "/permissions").json();
    }
    /**
     * No description
     *
     * @tags Projects
     * @name AddPermissions
     * @operationId ProjectsController_AddPermissions
     * @summary Adds permissions for the layer, combining existing permissions with the given one.
     * @request POST:/projects/{name}/permissions
     * @response `200` Success
     */

  }, {
    key: "addPermissions",
    value: function addPermissions(name, data) {
      return this.http.post("/projects/" + name + "/permissions", data).json();
    }
    /**
     * No description
     *
     * @tags Projects
     * @name SetPermissions
     * @operationId ProjectsController_SetPermissions
     * @summary Replaces existing access control list for the layer with the given one.
     * @request PUT:/projects/{name}/permissions
     * @response `200` Success
     */

  }, {
    key: "setPermissions",
    value: function setPermissions(name, data) {
      return this.http.put("/projects/" + name + "/permissions", data).json();
    }
    /**
     * No description
     *
     * @tags Projects
     * @name RemovePermissions
     * @operationId ProjectsController_RemovePermissions
     * @summary Removes permissions for the layer for the given role.
     * @request DELETE:/projects/{name}/permissions/{role}
     * @response `200` Success
     */

  }, {
    key: "removePermissions",
    value: function removePermissions(name, role) {
      return this.http.delete("/projects/" + name + "/permissions/" + role, null).json();
    }
  }]);

  return ProjectsService;
}(Service);

let Projects = /*#__PURE__*/function (_ProjectsService) {
  _inherits(Projects, _ProjectsService);

  var _super = /*#__PURE__*/_createSuper(Projects);

  function Projects() {
    _classCallCheck(this, Projects);

    return _super.apply(this, arguments);
  }

  _createClass(Projects, [{
    key: "getProjectInfos",
    value: function getProjectInfos(projects) {
      return promiseAllIgnoreErrors(projects.map(project => this.getProjectInfo(project)));
    }
  }, {
    key: "getProjectsDeps",
    value: function getProjectsDeps(proejcts) {
      return promiseAllIgnoreErrors(proejcts.map(project => this.getResourceDependencies(project)));
    }
  }, {
    key: "uploadPreview",
    value: function uploadPreview(name, file) {
      return this.setPreview(name, {
        file
      });
    }
  }, {
    key: "findOne",
    value: function findOne(name) {
      return this.getProjectInfo(name);
    }
  }, {
    key: "findAll",
    value: function findAll(params) {
      return this.getProjectsList(params);
    }
  }, {
    key: "create",
    value: function create(resource) {
      return this.createProject(resource);
    }
  }, {
    key: "update",
    value: function update(resource) {
      return this.updateProject(resource.name, resource);
    }
  }, {
    key: "remove",
    value: async function remove(name) {
      await this.deleteResource(name);
      return name;
    }
  }]);

  return Projects;
}(ProjectsService);
function isProjectContentItems(v) {
  return v !== null && v !== undefined;
}

function unique(value, index, array) {
  return array.indexOf(value) === index;
}

function isString(v) {
  return typeof v === 'string';
}

var DependencyType;

(function (DependencyType) {
  DependencyType["Layer"] = "Layer";
  DependencyType["Table"] = "Table";
  DependencyType["Project"] = "Project";
})(DependencyType || (DependencyType = {}));

let Resources = /*#__PURE__*/function () {
  function Resources(projects, layers, tables) {
    _classCallCheck(this, Resources);

    this.projects = projects;
    this.layers = layers;
    this.tables = tables;
  }

  _createClass(Resources, [{
    key: "getProjectInfosWithDeps",
    value: async function getProjectInfosWithDeps(projects) {
      const projectInfos = await this.projects.getProjectInfos(projects);
      const projectDeps = await this.projects.getProjectsDeps(projects);
      const {
        layers,
        tables
      } = await this.getDependencies(projectDeps, true, true);
      return {
        projects: projectInfos,
        deps: {
          layers,
          tables
        }
      };
    }
  }, {
    key: "getLayerInfosWithDeps",
    value: async function getLayerInfosWithDeps(layers) {
      const layerInfos = await this.layers.getLayerInfos(layers);
      const layersDeps = await this.layers.getLayersDeps(layers);
      const {
        tables
      } = await this.getDependencies(layersDeps, false, true);
      return {
        layers: layerInfos,
        deps: {
          tables
        }
      };
    }
  }, {
    key: "getDependencies",
    value: async function getDependencies(resourceDeps, pickLayers, pickTables) {
      const {
        tables,
        layers
      } = resourceDeps.reduce((acc, layerDep) => {
        const deps = layerDep.dependencies || [];

        if (pickLayers) {
          const layerNames = this.getDependentNames(deps, DependencyType.Layer);
          acc.layers.push(...layerNames);
        }

        if (pickTables) {
          const tableNames = this.getDependentNames(deps, DependencyType.Table);
          acc.tables.push(...tableNames);
        }

        return acc;
      }, {
        tables: [],
        layers: []
      });
      return {
        tables: await this.tables.getTableInfos(tables.filter(unique)),
        layers: await this.layers.getLayerInfos(layers.filter(unique))
      };
    }
  }, {
    key: "getDependentNames",
    value: function getDependentNames(deps, depType) {
      return deps.filter(_ref => {
        let {
          type
        } = _ref;
        return type === depType;
      }).map(_ref2 => {
        let {
          name
        } = _ref2;
        return name;
      }).filter(isString);
    }
  }]);

  return Resources;
}();

/**
 * @title Spatial Processing Core API
 * @version 1.0.0
 * @baseUrl /sp
 */

let StyleService = /*#__PURE__*/function (_Service) {
  _inherits(StyleService, _Service);

  var _super = /*#__PURE__*/_createSuper(StyleService);

  function StyleService() {
    _classCallCheck(this, StyleService);

    return _super.apply(this, arguments);
  }

  _createClass(StyleService, [{
    key: "getStyle",
    value:
    /**
     * No description
     *
     * @tags StyleService
     * @name GetStyle
     * @operationId StyleServiceController_GetStyle
     * @summary Returns the style by its id.
     * @request GET:/styles/{id}
     * @response `200` Success
     */
    function getStyle(id) {
      return this.http.get("/styles/" + id).json();
    }
    /**
     * No description
     *
     * @tags StyleService
     * @name UpdateStyle
     * @operationId StyleServiceController_UpdateStyle
     * @summary Replaces a style and gives it a new id.
     * @request POST:/styles/{id}
     * @response `200` Success
     */

  }, {
    key: "updateStyle",
    value: function updateStyle(id, data) {
      return this.http.post("/styles/" + id, data).json();
    }
    /**
     * No description
     *
     * @tags StyleService
     * @name CreateStyle
     * @operationId StyleServiceController_CreateStyle
     * @summary Creates a new style.
     * @request POST:/styles
     * @response `200` Success
     */

  }, {
    key: "createStyle",
    value: function createStyle(data) {
      return this.http.post("/styles", data).json();
    }
    /**
     * No description
     *
     * @tags StyleService
     * @name GetAllFonts
     * @operationId StyleServiceController_GetAllFonts
     * @summary Gets all installed fonts.
     * @request GET:/styles/fonts
     * @response `200` Success
     */

  }, {
    key: "getAllFonts",
    value: function getAllFonts() {
      return this.http.get("/styles/fonts").json();
    }
    /**
     * No description
     *
     * @tags StyleService
     * @name AddFont
     * @operationId StyleServiceController_AddFont
     * @summary Install new font.
     * @request POST:/styles/fonts
     * @response `200` Success
     */

  }, {
    key: "addFont",
    value: function addFont(data) {
      return this.http.post("/styles/fonts", toFormData(data)).then(() => {});
    }
    /**
     * No description
     *
     * @tags StyleService
     * @name RemoveFont
     * @operationId StyleServiceController_RemoveFont
     * @summary Remove installed font.
     * @request DELETE:/styles/fonts
     * @response `200` Success
     */

  }, {
    key: "removeFont",
    value: function removeFont(query) {
      return this.http.delete("/styles/fonts", null, query).then(() => {});
    }
  }]);

  return StyleService;
}(Service);

let Styles = /*#__PURE__*/function (_StyleService) {
  _inherits(Styles, _StyleService);

  var _super = /*#__PURE__*/_createSuper(Styles);

  function Styles() {
    _classCallCheck(this, Styles);

    return _super.apply(this, arguments);
  }

  return _createClass(Styles);
}(StyleService);

const _excluded$4 = ["providerName"],
      _excluded2$2 = ["providerName"],
      _excluded3$2 = ["providerName"];
/**
 * @title Spatial Processing Core API
 * @version 1.0.0
 * @baseUrl /sp
 */

let GeocodeService = /*#__PURE__*/function (_Service) {
  _inherits(GeocodeService, _Service);

  var _super = /*#__PURE__*/_createSuper(GeocodeService);

  function GeocodeService() {
    _classCallCheck(this, GeocodeService);

    return _super.apply(this, arguments);
  }

  _createClass(GeocodeService, [{
    key: "geocode",
    value:
    /**
     * No description
     *
     * @tags GeocodeService
     * @name Geocode
     * @operationId GeocodeServiceController_Geocode
     * @summary Returns geocode geometry.
     * @request GET:/geocode/{providerName}
     * @response `200` Success
     */
    function geocode(_ref) {
      let {
        providerName
      } = _ref,
          query = _objectWithoutPropertiesLoose(_ref, _excluded$4);

      return this.http.get("/geocode/" + providerName, query).json();
    }
    /**
     * No description
     *
     * @tags GeocodeService
     * @name GeocodeByPoint
     * @operationId GeocodeServiceController_GeocodeByPoint
     * @summary Returns geocode address from point geometry.
     * @request GET:/geocode/{providerName}/geocodeByPoint
     * @response `200` Success
     */

  }, {
    key: "geocodeByPoint",
    value: function geocodeByPoint(_ref2) {
      let {
        providerName
      } = _ref2,
          query = _objectWithoutPropertiesLoose(_ref2, _excluded2$2);

      return this.http.get("/geocode/" + providerName + "/geocodeByPoint", query).json();
    }
    /**
     * No description
     *
     * @tags GeocodeService
     * @name Suggest
     * @operationId GeocodeServiceController_Suggest
     * @summary Returns geocode suggest.
     * @request GET:/geocode/{providerName}/suggest
     * @response `200` Success
     */

  }, {
    key: "suggest",
    value: function suggest(_ref3) {
      let {
        providerName
      } = _ref3,
          query = _objectWithoutPropertiesLoose(_ref3, _excluded3$2);

      return this.http.get("/geocode/" + providerName + "/suggest", query).json();
    }
  }]);

  return GeocodeService;
}(Service);

const GEOCODE_PROVIDER = 'geocode2gis';
let Geocode = /*#__PURE__*/function (_GeocodeService) {
  _inherits(Geocode, _GeocodeService);

  var _super = /*#__PURE__*/_createSuper(Geocode);

  function Geocode() {
    _classCallCheck(this, Geocode);

    return _super.apply(this, arguments);
  }

  _createClass(Geocode, [{
    key: "geocode2Gis",
    value: function geocode2Gis(params) {
      return this.geocode(_extends({
        providerName: GEOCODE_PROVIDER
      }, params));
    }
  }, {
    key: "suggest2Gis",
    value: function suggest2Gis(params) {
      return this.suggest(_extends({
        providerName: GEOCODE_PROVIDER
      }, params));
    }
  }]);

  return Geocode;
}(GeocodeService);

/**
 * @title Spatial Processing Core API
 * @version 1.0.0
 * @baseUrl /sp
 */

let ResourceCatalogService = /*#__PURE__*/function (_Service) {
  _inherits(ResourceCatalogService, _Service);

  var _super = /*#__PURE__*/_createSuper(ResourceCatalogService);

  function ResourceCatalogService() {
    _classCallCheck(this, ResourceCatalogService);

    return _super.apply(this, arguments);
  }

  _createClass(ResourceCatalogService, [{
    key: "checkLimits",
    value:
    /**
     * @description This method requires superuser permission.
     *
     * @tags ResourceCatalog
     * @name CheckLimits
     * @operationId ResourceCatalogController_CheckLimits
     * @summary Get limits of workspace.
     * @request GET:/resources/checkLimits
     * @response `200` Success
     */
    function checkLimits(query) {
      return this.http.get("/resources/checkLimits", query).json();
    }
    /**
     * No description
     *
     * @tags ResourceCatalog
     * @name CopyResources
     * @operationId ResourceCatalogController_CopyResources
     * @summary Copy a set of resources.
     * @request POST:/resources/copy
     * @response `200` Success
     */

  }, {
    key: "copyResources",
    value: function copyResources(data) {
      return this.http.post("/resources/copy", data).json();
    }
  }]);

  return ResourceCatalogService;
}(Service);

let ResourceCatalog = /*#__PURE__*/function (_ResourceCatalogServi) {
  _inherits(ResourceCatalog, _ResourceCatalogServi);

  var _super = /*#__PURE__*/_createSuper(ResourceCatalog);

  function ResourceCatalog() {
    _classCallCheck(this, ResourceCatalog);

    return _super.apply(this, arguments);
  }

  return _createClass(ResourceCatalog);
}(ResourceCatalogService);

/**
 * @title Spatial Processing Core API
 * @version 1.0.0
 * @baseUrl /sp
 */

let ToolsService = /*#__PURE__*/function (_Service) {
  _inherits(ToolsService, _Service);

  var _super = /*#__PURE__*/_createSuper(ToolsService);

  function ToolsService() {
    _classCallCheck(this, ToolsService);

    return _super.apply(this, arguments);
  }

  return _createClass(ToolsService);
}(Service);

let Tools = /*#__PURE__*/function (_ToolsService) {
  _inherits(Tools, _ToolsService);

  var _super = /*#__PURE__*/_createSuper(Tools);

  function Tools() {
    _classCallCheck(this, Tools);

    return _super.apply(this, arguments);
  }

  return _createClass(Tools);
}(ToolsService);

/**
 * @title Spatial Processing Core API
 * @version 1.0.0
 * @baseUrl /sp
 */

let GeneralService = /*#__PURE__*/function (_Service) {
  _inherits(GeneralService, _Service);

  var _super = /*#__PURE__*/_createSuper(GeneralService);

  function GeneralService() {
    _classCallCheck(this, GeneralService);

    return _super.apply(this, arguments);
  }

  _createClass(GeneralService, [{
    key: "getServerInfo",
    value:
    /**
     * No description
     *
     * @tags General
     * @name GetServerInfo
     * @operationId GeneralController_GetServerInfo
     * @summary Returns basic information about the server.
     * @request GET:/
     * @response `200` Success
     */
    function getServerInfo() {
      return this.http.get("/").json();
    }
    /**
     * No description
     *
     * @tags General
     * @name CancelTest
     * @operationId GeneralController_CancelTest
     * @summary Test method for CancellationToken.
     * @request GET:/cancel
     * @response `200` Success
     */

  }, {
    key: "cancelTest",
    value: function cancelTest(query) {
      return this.http.get("/cancel", query).then(() => {});
    }
    /**
     * No description
     *
     * @tags General
     * @name GetFunctionsList
     * @operationId GeneralController_GetFunctionsList
     * @summary Returns list of available functions.
     * @request GET:/functions
     * @response `200` Success
     */

  }, {
    key: "getFunctionsList",
    value: function getFunctionsList() {
      return this.http.get("/functions").json();
    }
  }]);

  return GeneralService;
}(Service);

let General = /*#__PURE__*/function (_GeneralService) {
  _inherits(General, _GeneralService);

  var _super = /*#__PURE__*/_createSuper(General);

  function General() {
    _classCallCheck(this, General);

    return _super.apply(this, arguments);
  }

  return _createClass(General);
}(GeneralService);

/**
 * @title Spatial Processing Core API
 * @version 1.0.0
 * @baseUrl /sp
 */

let NamespaceService = /*#__PURE__*/function (_Service) {
  _inherits(NamespaceService, _Service);

  var _super = /*#__PURE__*/_createSuper(NamespaceService);

  function NamespaceService() {
    _classCallCheck(this, NamespaceService);

    return _super.apply(this, arguments);
  }

  _createClass(NamespaceService, [{
    key: "getNamespaces",
    value:
    /**
     * No description
     *
     * @tags Namespace
     * @name GetNamespaces
     * @operationId NamespaceController_GetNamespacesAsync
     * @summary Returns the list of existing namespaces, that correspond to the given conditions.
     * @request GET:/namespaces
     * @response `200` Success
     */
    function getNamespaces(query) {
      return this.http.get("/namespaces", query).json();
    }
    /**
     * No description
     *
     * @tags Namespace
     * @name CreateNamespace
     * @operationId NamespaceController_CreateNamespace
     * @summary Creates a new namespace.
     * @request POST:/namespaces
     * @response `200` Success
     */

  }, {
    key: "createNamespace",
    value: function createNamespace(query) {
      return this.http.post("/namespaces", null, query).json();
    }
    /**
     * No description
     *
     * @tags Namespace
     * @name GetNamespace
     * @operationId NamespaceController_GetNamespaceAsync
     * @summary Get namespace information.
     * @request GET:/namespaces/{namespace}
     * @response `200` Success
     */

  }, {
    key: "getNamespace",
    value: function getNamespace(namespace) {
      return this.http.get("/namespaces/" + namespace).json();
    }
    /**
     * No description
     *
     * @tags Namespace
     * @name RemoveNamespace
     * @operationId NamespaceController_RemoveNamespaceAsync
     * @summary Remove namespace.
     * @request DELETE:/namespaces/{namespace}
     * @response `200` Success
     */

  }, {
    key: "removeNamespace",
    value: function removeNamespace(namespace) {
      return this.http.delete("/namespaces/" + namespace, null).then(() => {});
    }
  }]);

  return NamespaceService;
}(Service);

let Namespace = /*#__PURE__*/function (_NamespaceService) {
  _inherits(Namespace, _NamespaceService);

  var _super = /*#__PURE__*/_createSuper(Namespace);

  function Namespace() {
    _classCallCheck(this, Namespace);

    return _super.apply(this, arguments);
  }

  return _createClass(Namespace);
}(NamespaceService);

/**
 * @title Spatial Processing Core API
 * @version 1.0.0
 * @baseUrl /sp
 */

let AccountService = /*#__PURE__*/function (_Service) {
  _inherits(AccountService, _Service);

  var _super = /*#__PURE__*/_createSuper(AccountService);

  function AccountService() {
    _classCallCheck(this, AccountService);

    return _super.apply(this, arguments);
  }

  _createClass(AccountService, [{
    key: "getUsers",
    value:
    /**
     * No description
     *
     * @tags Account
     * @name GetUsers
     * @operationId AccountController_GetUsers
     * @summary Returns the list of users that correspond to the given conditions.
     * @request GET:/account/user/list
     * @response `200` Success
     */
    function getUsers(query) {
      return this.http.get("/account/user/list", query).json();
    }
    /**
     * No description
     *
     * @tags Account
     * @name GetExtendedUsers
     * @operationId AccountController_GetExtendedUsers
     * @summary Returns the list of extended users informations that correspond to the given conditions.
     * @request GET:/account/user/extendedlist
     * @response `200` Success
     */

  }, {
    key: "getExtendedUsers",
    value: function getExtendedUsers(query) {
      return this.http.get("/account/user/extendedlist", query).json();
    }
    /**
     * No description
     *
     * @tags Account
     * @name GetUserInfo
     * @operationId AccountController_GetUserInfo
     * @summary Get user basic information.
     * @request GET:/account/{username}
     * @response `200` Success
     */

  }, {
    key: "getUserInfo",
    value: function getUserInfo(username) {
      return this.http.get("/account/" + username).json();
    }
    /**
     * No description
     *
     * @tags Account
     * @name GetExtendedUserInfo
     * @operationId AccountController_GetExtendedUserInfo
     * @summary Get user extended information.
     * @request GET:/account/extended/{username}
     * @response `200` Success
     */

  }, {
    key: "getExtendedUserInfo",
    value: function getExtendedUserInfo(username) {
      return this.http.get("/account/extended/" + username).json();
    }
    /**
     * No description
     *
     * @tags Account
     * @name IsUsernameExists
     * @operationId AccountController_IsUsernameExists
     * @summary Checks if the user with the given name is registered in the system.
     * @request GET:/account/user/exists
     * @response `200` Success
     */

  }, {
    key: "isUsernameExists",
    value: function isUsernameExists(query) {
      return this.http.get("/account/user/exists", query).json();
    }
    /**
     * No description
     *
     * @tags Account
     * @name IsEmailExists
     * @operationId AccountController_IsEmailExists
     * @summary Checks if the user with the given email is registered in the system.
     * @request GET:/account/user/email/exists
     * @response `200` Success
     */

  }, {
    key: "isEmailExists",
    value: function isEmailExists(query) {
      return this.http.get("/account/user/email/exists", query).json();
    }
    /**
     * No description
     *
     * @tags Account
     * @name RegisterUser
     * @operationId AccountController_RegisterUser
     * @summary Register new user.
     * @request POST:/account/register
     * @response `200` Success
     */

  }, {
    key: "registerUser",
    value: function registerUser(data) {
      return this.http.post("/account/register", data).text();
    }
    /**
     * @description Only for users with SPCore.Security.ISecurityManager.SuperuserRole role.
     *
     * @tags Account
     * @name CreateUser
     * @operationId AccountController_CreateUser
     * @summary Create new user.
     * @request POST:/account/user
     * @response `200` Success
     */

  }, {
    key: "createUser",
    value: function createUser(query, data) {
      return this.http.post("/account/user", data, query).then(() => {});
    }
    /**
     * No description
     *
     * @tags Account
     * @name UpdateUser
     * @operationId AccountController_UpdateUser
     * @summary Update exist user.
     * @request PATCH:/account/user
     * @response `200` Success
     */

  }, {
    key: "updateUser",
    value: function updateUser(data) {
      return this.http.patch("/account/user", data).then(() => {});
    }
    /**
     * @description Only for users with SPCore.Security.ISecurityManager.SuperuserRole role.
     *
     * @tags Account
     * @name ConfirmEmail
     * @operationId AccountController_ConfirmEmail
     * @summary Confirm user email.
     * @request POST:/account/user/{username}/email/confirm
     * @response `200` Success
     */

  }, {
    key: "confirmEmail",
    value: function confirmEmail(username) {
      return this.http.post("/account/user/" + username + "/email/confirm", null).then(() => {});
    }
    /**
     * No description
     *
     * @tags Account
     * @name VerifyEmail
     * @operationId AccountController_VerifyEmail
     * @summary Send email with verification code.
     * @request POST:/account/user/{username}/email/verify
     * @response `200` Success
     */

  }, {
    key: "verifyEmail",
    value: function verifyEmail(username) {
      return this.http.post("/account/user/" + username + "/email/verify", null).then(() => {});
    }
    /**
     * No description
     *
     * @tags Account
     * @name SetEmail
     * @operationId AccountController_SetEmail
     * @summary For a user that does not have a set email, sets the email and password. Requires email confirmation through link.
     * @request POST:/account/setEmail
     * @response `200` Success
     */

  }, {
    key: "setEmail",
    value: function setEmail(data) {
      return this.http.post("/account/setEmail", toFormData(data)).then(() => {});
    }
    /**
     * No description
     *
     * @tags Account
     * @name ConfirmEmail1
     * @operationId AccountController_ConfirmEmail_1
     * @summary Confirm user email by code.
     * @request POST:/account/user/email/confirm
     * @response `200` Success
     */

  }, {
    key: "confirmEmail1",
    value: function confirmEmail1(query) {
      return this.http.post("/account/user/email/confirm", null, query).then(() => {});
    }
    /**
     * No description
     *
     * @tags Account
     * @name ChangeEmail
     * @operationId AccountController_ChangeEmail
     * @summary Send email message with confirmation code to new email address.
     * @request POST:/account/user/email/change
     * @response `200` Success
     */

  }, {
    key: "changeEmail",
    value: function changeEmail(query) {
      return this.http.post("/account/user/email/change", null, query).then(() => {});
    }
    /**
     * No description
     *
     * @tags Account
     * @name ConfirmChangeEmail
     * @operationId AccountController_ConfirmChangeEmail
     * @summary Check confirmation code and change email address.
     * @request POST:/account/user/email/change/confirm
     * @response `200` Success
     */

  }, {
    key: "confirmChangeEmail",
    value: function confirmChangeEmail(query) {
      return this.http.post("/account/user/email/change/confirm", null, query).then(() => {});
    }
    /**
     * No description
     *
     * @tags Account
     * @name SetUserPassword
     * @operationId AccountController_SetUserPassword
     * @summary Set user password.
     * @request PATCH:/account/password/set
     * @response `200` Success
     */

  }, {
    key: "setUserPassword",
    value: function setUserPassword(data) {
      return this.http.patch("/account/password/set", data).then(() => {});
    }
    /**
     * No description
     *
     * @tags Account
     * @name ChangePassword
     * @operationId AccountController_ChangePassword
     * @summary Change current user password.
     * @request PATCH:/account/password/change
     * @response `200` Success
     */

  }, {
    key: "changePassword",
    value: function changePassword(data) {
      return this.http.patch("/account/password/change", toFormData(data)).then(() => {});
    }
    /**
     * No description
     *
     * @tags Account
     * @name ResetPassword
     * @operationId AccountController_ResetPassword
     * @summary Send reset password message.
     * @request POST:/account/password/reset
     * @response `200` Success
     */

  }, {
    key: "resetPassword",
    value: function resetPassword(query) {
      return this.http.post("/account/password/reset", null, query).then(() => {});
    }
    /**
     * No description
     *
     * @tags Account
     * @name ResetPasswordCallback
     * @operationId AccountController_ResetPasswordCallback
     * @summary Reset password.
     * @request POST:/account/password/reset/confirm
     * @response `200` Success
     */

  }, {
    key: "resetPasswordCallback",
    value: function resetPasswordCallback(data) {
      return this.http.post("/account/password/reset/confirm", toFormData(data)).then(() => {});
    }
    /**
     * No description
     *
     * @tags Account
     * @name RemoveUser
     * @operationId AccountController_RemoveUser
     * @summary Remove user.
     * @request DELETE:/account/user/{username}
     * @response `200` Success
     */

  }, {
    key: "removeUser",
    value: function removeUser(username) {
      return this.http.delete("/account/user/" + username, null).then(() => {});
    }
    /**
     * No description
     *
     * @tags Account
     * @name ActivateUser
     * @operationId AccountController_ActivateUser
     * @summary Activate user.
     * @request POST:/account/user/{username}/activate
     * @response `200` Success
     */

  }, {
    key: "activateUser",
    value: function activateUser(username) {
      return this.http.post("/account/user/" + username + "/activate", null).then(() => {});
    }
    /**
     * No description
     *
     * @tags Account
     * @name DeactivateUser
     * @operationId AccountController_DeactivateUser
     * @summary Deactivate user.
     * @request POST:/account/user/{username}/deactivate
     * @response `200` Success
     */

  }, {
    key: "deactivateUser",
    value: function deactivateUser(username) {
      return this.http.post("/account/user/" + username + "/deactivate", null).then(() => {});
    }
    /**
     * No description
     *
     * @tags Account
     * @name Authenticate
     * @operationId AccountController_Authenticate
     * @summary Login.
     * @request POST:/account/login
     * @response `200` Success
     */

  }, {
    key: "authenticate",
    value: function authenticate(data) {
      return this.http.post("/account/login", data).text();
    }
    /**
     * No description
     *
     * @tags Account
     * @name RefreshToken
     * @operationId AccountController_RefreshToken
     * @summary Refresh JWT token.
     * @request POST:/account/refresh-token
     * @response `200` Success
     */

  }, {
    key: "refreshToken",
    value: function refreshToken() {
      return this.http.post("/account/refresh-token", null).text();
    }
    /**
     * No description
     *
     * @tags Account
     * @name RevokeToken
     * @operationId AccountController_RevokeToken
     * @summary Revoke refresh token.
     * @request DELETE:/account/revoke-token
     * @response `200` Success
     */

  }, {
    key: "revokeToken",
    value: function revokeToken() {
      return this.http.delete("/account/revoke-token", null).then(() => {});
    }
    /**
     * No description
     *
     * @tags Account
     * @name LdapLogin
     * @operationId AccountController_LdapLogin
     * @summary The external login callback.
     * @request POST:/account/external/login/ldap
     * @response `200` Success
     */

  }, {
    key: "ldapLogin",
    value: function ldapLogin(data) {
      return this.http.post("/account/external/login/ldap", data).then(() => {});
    }
    /**
     * No description
     *
     * @tags Account
     * @name GetRoles
     * @operationId AccountController_GetRoles
     * @summary Enumerate exist roles.
     * @request GET:/account/role/list
     * @response `200` Success
     */

  }, {
    key: "getRoles",
    value: function getRoles(query) {
      return this.http.get("/account/role/list", query).json();
    }
    /**
     * No description
     *
     * @tags Account
     * @name CreateRole
     * @operationId AccountController_CreateRole
     * @summary Create new role.
     * @request POST:/account/role
     * @response `200` Success
     */

  }, {
    key: "createRole",
    value: function createRole(data) {
      return this.http.post("/account/role", data).then(() => {});
    }
    /**
     * No description
     *
     * @tags Account
     * @name UpdateRole
     * @operationId AccountController_UpdateRole
     * @summary Update exist role.
     * @request PATCH:/account/role
     * @response `200` Success
     */

  }, {
    key: "updateRole",
    value: function updateRole(data) {
      return this.http.patch("/account/role", data).then(() => {});
    }
    /**
     * No description
     *
     * @tags Account
     * @name RemoveRole
     * @operationId AccountController_RemoveRole
     * @summary Remove role.
     * @request DELETE:/account/role/{rolename}
     * @response `200` Success
     */

  }, {
    key: "removeRole",
    value: function removeRole(rolename) {
      return this.http.delete("/account/role/" + rolename, null).then(() => {});
    }
    /**
     * No description
     *
     * @tags Account
     * @name AddToRole
     * @operationId AccountController_AddToRole
     * @summary Add user to role.
     * @request POST:/account/user/{username}/role/{role}
     * @response `200` Success
     */

  }, {
    key: "addToRole",
    value: function addToRole(username, role) {
      return this.http.post("/account/user/" + username + "/role/" + role, null).then(() => {});
    }
    /**
     * No description
     *
     * @tags Account
     * @name RemoveFromRole
     * @operationId AccountController_RemoveFromRole
     * @summary Remove user from role.
     * @request DELETE:/account/user/{username}/role/{role}
     * @response `200` Success
     */

  }, {
    key: "removeFromRole",
    value: function removeFromRole(username, role) {
      return this.http.delete("/account/user/" + username + "/role/" + role, null).then(() => {});
    }
    /**
     * No description
     *
     * @tags Account
     * @name PostUsedProjects
     * @operationId AccountController_PostUsedProjects
     * @summary Set used project.
     * @request POST:/account/latest_projects
     * @response `200` Success
     */

  }, {
    key: "postUsedProjects",
    value: function postUsedProjects(data) {
      return this.http.post("/account/latest_projects", data).json();
    }
    /**
     * No description
     *
     * @tags Account
     * @name GetUsedProjects
     * @operationId AccountController_GetUsedProjects
     * @summary Get used projects.
     * @request GET:/account/latest_projects
     * @response `200` Success
     */

  }, {
    key: "getUsedProjects",
    value: function getUsedProjects() {
      return this.http.get("/account/latest_projects").json();
    }
    /**
     * No description
     *
     * @tags Account
     * @name TruncateUsedProjects
     * @operationId AccountController_TruncateUsedProjects
     * @summary Truncate used projects.
     * @request DELETE:/account/latest_projects
     * @response `200` Success
     */

  }, {
    key: "truncateUsedProjects",
    value: function truncateUsedProjects() {
      return this.http.delete("/account/latest_projects", null).then(() => {});
    }
  }]);

  return AccountService;
}(Service);

const API_USER_INFO_KEY = '@evergis/user-info';

const getUserInfo = () => JSON.parse(localStorage.getItem(API_USER_INFO_KEY) || 'null') || void 0;
const updateUserInfo = newUserInfo => {
  if (newUserInfo) {
    const oldUserInfo = getUserInfo();
    localStorage.setItem(API_USER_INFO_KEY, JSON.stringify(_extends({}, oldUserInfo, newUserInfo)));
  } else {
    localStorage.removeItem(API_USER_INFO_KEY);
  }
};

let Account = /*#__PURE__*/function (_AccountService) {
  _inherits(Account, _AccountService);

  var _super = /*#__PURE__*/_createSuper(Account);

  function Account() {
    _classCallCheck(this, Account);

    return _super.apply(this, arguments);
  }

  _createClass(Account, [{
    key: "login",
    value: async function login(params) {
      if (params) {
        await _get(_getPrototypeOf(Account.prototype), "authenticate", this).call(this, params);
      }
    }
  }, {
    key: "fetchCurrentUser",
    value: async function fetchCurrentUser() {
      this.userInfo = await this.getUserInfo('');
      return this.userInfo;
    }
  }, {
    key: "username",
    get: function get() {
      var _this$userInfo;

      return ((_this$userInfo = this.userInfo) == null ? void 0 : _this$userInfo.username) || '';
    }
  }, {
    key: "logout",
    value: async function logout() {
      await this.revokeToken();
      updateUserInfo(void 0);
      this.userInfo = {};
    }
  }, {
    key: "updateCurrentUser",
    value: async function updateCurrentUser(userInfo) {
      await _get(_getPrototypeOf(Account.prototype), "updateUser", this).call(this, _extends({
        username: this.username
      }, userInfo));
      updateUserInfo(userInfo);
    }
  }, {
    key: "setPassword",
    value: function setPassword(password) {
      return this.setUserPassword({
        username: this.username,
        password
      });
    }
  }, {
    key: "isAuth",
    get: function get() {
      var _this$userInfo2;

      return !!((_this$userInfo2 = this.userInfo) != null && _this$userInfo2.username) && this.userInfo.username !== 'public';
    }
  }, {
    key: "user",
    get: function get() {
      if (this.userInfo) {
        return this.userInfo;
      }

      const userInfo = getUserInfo();

      if (userInfo) {
        this.userInfo = userInfo;
      }

      return userInfo;
    }
  }]);

  return Account;
}(AccountService);

const _excluded$5 = ["username"];
/**
 * @title Spatial Processing Core API
 * @version 1.0.0
 * @baseUrl /sp
 */

let AccountPreviewService = /*#__PURE__*/function (_Service) {
  _inherits(AccountPreviewService, _Service);

  var _super = /*#__PURE__*/_createSuper(AccountPreviewService);

  function AccountPreviewService() {
    _classCallCheck(this, AccountPreviewService);

    return _super.apply(this, arguments);
  }

  _createClass(AccountPreviewService, [{
    key: "getPreview",
    value:
    /**
     * No description
     *
     * @tags AccountPreview
     * @name GetPreview
     * @operationId AccountPreviewController_GetPreview
     * @summary Get user preview image.
     * @request GET:/account/user/preview/{username}
     * @response `200` Success
     */
    function getPreview(username) {
      return this.http.createUrl("/account/user/preview/" + username);
    }
    /**
     * No description
     *
     * @tags AccountPreview
     * @name UploadPreview
     * @operationId AccountPreviewController_UploadPreview
     * @summary Set user preview image by link.
     * @request POST:/account/user/preview/{username}
     * @response `200` Success
     */

  }, {
    key: "uploadPreview",
    value: function uploadPreview(_ref, data) {
      let {
        username
      } = _ref,
          query = _objectWithoutPropertiesLoose(_ref, _excluded$5);

      return this.http.post("/account/user/preview/" + username, toFormData(data), query).json();
    }
    /**
     * No description
     *
     * @tags AccountPreview
     * @name DeletePreview
     * @operationId AccountPreviewController_DeletePreview
     * @summary Delete user preview.
     * @request DELETE:/account/user/preview/{username}
     * @response `200` Success
     */

  }, {
    key: "deletePreview",
    value: function deletePreview(username) {
      return this.http.delete("/account/user/preview/" + username, null).then(() => {});
    }
  }]);

  return AccountPreviewService;
}(Service);

let AccountPreview = /*#__PURE__*/function (_AccountPreviewServic) {
  _inherits(AccountPreview, _AccountPreviewServic);

  var _super = /*#__PURE__*/_createSuper(AccountPreview);

  function AccountPreview(http, account) {
    var _this;

    _classCallCheck(this, AccountPreview);

    _this = _super.call(this, http);
    _this.userInfo = account;
    return _this;
  }

  _createClass(AccountPreview, [{
    key: "user",
    get: function get() {
      if (this.userInfo) {
        return this.userInfo;
      }

      const userInfo = getUserInfo();

      if (userInfo) {
        this.userInfo = userInfo;
      }

      return userInfo;
    }
  }, {
    key: "username",
    get: function get() {
      var _this$userInfo;

      return ((_this$userInfo = this.userInfo) == null ? void 0 : _this$userInfo.username) || '';
    }
  }, {
    key: "updateCurrentUserPhoto",
    value: async function updateCurrentUserPhoto(file, payload) {
      const {
        fileId
      } = await this.uploadPreview(_extends({
        username: this.username
      }, payload), {
        file
      });
      updateUserInfo({
        profile_photo: fileId,
        has_profile_photo: true
      });
    }
  }, {
    key: "fetchPreview1",
    value: async function fetchPreview1() {
      var _response$headers$get;

      const url = this.getPreview('');
      const response = await fetch(url);
      const profile_photo = (_response$headers$get = response.headers.get('content-type')) != null && _response$headers$get.includes('text/plain') ? await response.text() : url + "?r=" + Math.random();
      updateUserInfo({
        profile_photo,
        has_profile_photo: true
      });
    }
  }, {
    key: "deleteCurrentUserPhoto",
    value: async function deleteCurrentUserPhoto() {
      await this.deletePreview(this.username);
      updateUserInfo({
        profile_photo: '',
        has_profile_photo: false
      });
    }
  }]);

  return AccountPreview;
}(AccountPreviewService);

/**
 * @title Spatial Processing Core API
 * @version 1.0.0
 * @baseUrl /sp
 */

let ExternalProvidersService = /*#__PURE__*/function (_Service) {
  _inherits(ExternalProvidersService, _Service);

  var _super = /*#__PURE__*/_createSuper(ExternalProvidersService);

  function ExternalProvidersService() {
    _classCallCheck(this, ExternalProvidersService);

    return _super.apply(this, arguments);
  }

  _createClass(ExternalProvidersService, [{
    key: "vkLogin",
    value:
    /**
     * No description
     *
     * @tags ExternalProviders
     * @name VkLogin
     * @operationId ExternalProvidersController_VkLogin
     * @summary The external login by vk.
     * @request GET:/account/external/login/vk
     * @response `200` Success
     */
    function vkLogin() {
      return this.http.createUrl("/account/external/login/vk");
    }
    /**
     * No description
     *
     * @tags ExternalProviders
     * @name GoogleLogin
     * @operationId ExternalProvidersController_GoogleLogin
     * @summary The external login by google.
     * @request GET:/account/external/login/google
     * @response `200` Success
     */

  }, {
    key: "googleLogin",
    value: function googleLogin() {
      return this.http.createUrl("/account/external/login/google");
    }
    /**
     * No description
     *
     * @tags ExternalProviders
     * @name FacebookLogin
     * @operationId ExternalProvidersController_FacebookLogin
     * @summary The external login by facebook.
     * @request GET:/account/external/login/facebook
     * @response `200` Success
     */

  }, {
    key: "facebookLogin",
    value: function facebookLogin() {
      return this.http.createUrl("/account/external/login/facebook");
    }
    /**
     * No description
     *
     * @tags ExternalProviders
     * @name LoginCallback
     * @operationId ExternalProvidersController_LoginCallback
     * @summary The external login callback.
     * @request GET:/account/external/login/callback
     * @response `200` Success
     */

  }, {
    key: "loginCallback",
    value: function loginCallback() {
      return this.http.get("/account/external/login/callback").then(() => {});
    }
    /**
     * No description
     *
     * @tags ExternalProviders
     * @name UnbindVk
     * @operationId ExternalProvidersController_UnbindVk
     * @summary Unbind external login from current user account (google).
     * @request DELETE:/account/external/unbind/vk
     * @response `200` Success
     */

  }, {
    key: "unbindVk",
    value: function unbindVk() {
      return this.http.delete("/account/external/unbind/vk", null).then(() => {});
    }
    /**
     * No description
     *
     * @tags ExternalProviders
     * @name UnbindGoogle
     * @operationId ExternalProvidersController_UnbindGoogle
     * @summary Unbind external login from current user account (google).
     * @request DELETE:/account/external/unbind/google
     * @response `200` Success
     */

  }, {
    key: "unbindGoogle",
    value: function unbindGoogle() {
      return this.http.delete("/account/external/unbind/google", null).then(() => {});
    }
    /**
     * No description
     *
     * @tags ExternalProviders
     * @name UnbindFacebook
     * @operationId ExternalProvidersController_UnbindFacebook
     * @summary Unbind external login from current user account (google).
     * @request DELETE:/account/external/unbind/facebook
     * @response `200` Success
     */

  }, {
    key: "unbindFacebook",
    value: function unbindFacebook() {
      return this.http.delete("/account/external/unbind/facebook", null).then(() => {});
    }
    /**
     * No description
     *
     * @tags ExternalProviders
     * @name BindVk
     * @operationId ExternalProvidersController_BindVk
     * @summary The external login by vk.
     * @request GET:/account/external/bind/vk
     * @response `200` Success
     */

  }, {
    key: "bindVk",
    value: function bindVk() {
      return this.http.createUrl("/account/external/bind/vk");
    }
    /**
     * No description
     *
     * @tags ExternalProviders
     * @name BindGoogle
     * @operationId ExternalProvidersController_BindGoogle
     * @summary The external login by vk.
     * @request GET:/account/external/bind/google
     * @response `200` Success
     */

  }, {
    key: "bindGoogle",
    value: function bindGoogle() {
      return this.http.createUrl("/account/external/bind/google");
    }
    /**
     * No description
     *
     * @tags ExternalProviders
     * @name BindFacebook
     * @operationId ExternalProvidersController_BindFacebook
     * @summary The external login by vk.
     * @request GET:/account/external/bind/facebook
     * @response `200` Success
     */

  }, {
    key: "bindFacebook",
    value: function bindFacebook() {
      return this.http.createUrl("/account/external/bind/facebook");
    }
    /**
     * No description
     *
     * @tags ExternalProviders
     * @name BindCallback
     * @operationId ExternalProvidersController_BindCallback
     * @summary Bind external login to current user account.
     * @request GET:/account/external/bind/callback
     * @response `200` Success
     */

  }, {
    key: "bindCallback",
    value: function bindCallback() {
      return this.http.get("/account/external/bind/callback").then(() => {});
    }
  }]);

  return ExternalProvidersService;
}(Service);

let External = /*#__PURE__*/function (_ExternalProvidersSer) {
  _inherits(External, _ExternalProvidersSer);

  var _super = /*#__PURE__*/_createSuper(External);

  function External() {
    _classCallCheck(this, External);

    return _super.apply(this, arguments);
  }

  _createClass(External, [{
    key: "login",
    value: function login(network) {
      switch (network) {
        case 'vk':
          return this.vkLogin();

        case 'google':
          return this.googleLogin();

        case 'facebook':
          return this.facebookLogin();

        default:
          return '';
      }
    }
  }, {
    key: "bind",
    value: function bind(network) {
      switch (network) {
        case 'vk':
          return this.bindVk();

        case 'google':
          return this.bindGoogle();

        case 'facebook':
          return this.bindFacebook();

        default:
          return '';
      }
    }
  }, {
    key: "unbind",
    value: function unbind(network) {
      switch (network) {
        case 'vk':
          return this.unbindVk();

        case 'google':
          return this.unbindGoogle();

        case 'facebook':
          return this.unbindFacebook();

        default:
          return '';
      }
    }
  }]);

  return External;
}(ExternalProvidersService);

/**
 * @title Spatial Processing Core API
 * @version 1.0.0
 * @baseUrl /sp
 */

let ClientSettingsService = /*#__PURE__*/function (_Service) {
  _inherits(ClientSettingsService, _Service);

  var _super = /*#__PURE__*/_createSuper(ClientSettingsService);

  function ClientSettingsService() {
    _classCallCheck(this, ClientSettingsService);

    return _super.apply(this, arguments);
  }

  _createClass(ClientSettingsService, [{
    key: "getConfigurationsList",
    value:
    /**
     * No description
     *
     * @tags ClientSettings
     * @name GetConfigurationsList
     * @operationId ClientSettingsController_GetConfigurationsList
     * @summary Get client configurations.
     * @request GET:/settings/config
     * @response `200` Success
     */
    function getConfigurationsList(query) {
      return this.http.get("/settings/config", query).json();
    }
    /**
     * No description
     *
     * @tags ClientSettings
     * @name GetConfiguration
     * @operationId ClientSettingsController_GetConfiguration
     * @summary Get config for urlPath.
     * @request GET:/settings
     * @response `200` Success
     */

  }, {
    key: "getConfiguration",
    value: function getConfiguration(query) {
      return this.http.get("/settings", query).text();
    }
    /**
     * No description
     *
     * @tags ClientSettings
     * @name SetConfiguration
     * @operationId ClientSettingsController_SetConfiguration
     * @summary Set config for urlPath.
     * @request POST:/settings
     * @response `200` Success
     */

  }, {
    key: "setConfiguration",
    value: function setConfiguration(query, data) {
      return this.http.post("/settings", data, query).then(() => {});
    }
    /**
     * No description
     *
     * @tags ClientSettings
     * @name RemoveConfiguration
     * @operationId ClientSettingsController_RemoveConfiguration
     * @summary Remove config for urlPath.
     * @request DELETE:/settings
     * @response `200` Success
     */

  }, {
    key: "removeConfiguration",
    value: function removeConfiguration(query) {
      return this.http.delete("/settings", null, query).then(() => {});
    }
  }]);

  return ClientSettingsService;
}(Service);

let ClientSettings = /*#__PURE__*/function (_ClientSettingsServic) {
  _inherits(ClientSettings, _ClientSettingsServic);

  var _super = /*#__PURE__*/_createSuper(ClientSettings);

  function ClientSettings() {
    var _this;

    _classCallCheck(this, ClientSettings);

    _this = _super.apply(this, arguments);
    _this.settings = {
      modules: [],
      connection: {
        url: ''
      }
    };
    return _this;
  }

  _createClass(ClientSettings, [{
    key: "fetchClientSettings",
    value: async function fetchClientSettings(query) {
      const config = JSON.parse(await this.getConfiguration(query));
      this.updateClientSettings(config);
      return config;
    }
  }, {
    key: "updateClientSettings",
    value: function updateClientSettings(update) {
      Object.assign(this.settings, update);
    }
  }]);

  return ClientSettings;
}(ClientSettingsService);

let PortalSettings = /*#__PURE__*/function (_ClientSettingsServic) {
  _inherits(PortalSettings, _ClientSettingsServic);

  var _super = /*#__PURE__*/_createSuper(PortalSettings);

  function PortalSettings() {
    var _this;

    _classCallCheck(this, PortalSettings);

    _this = _super.apply(this, arguments);
    _this.config = null;
    return _this;
  }

  _createClass(PortalSettings, [{
    key: "fetchPortalSettings",
    value: async function fetchPortalSettings(query) {
      this.config = JSON.parse(await this.getConfiguration(query));
      return this.config;
    }
  }]);

  return PortalSettings;
}(ClientSettingsService);

var ErrorReason;

(function (ErrorReason) {
  /** When request has status code less than 400 */
  ErrorReason["HTTP_OTHER"] = "other";
  /** When request has status code in range 400 - 499 */

  ErrorReason["HTTP_CLIENT"] = "client";
  /** When request has status code 500 or more */

  ErrorReason["HTTP_SERVER"] = "server";
  /** When it's not a http bad response */

  ErrorReason["UNKNOWN"] = "unknown";
})(ErrorReason || (ErrorReason = {}));

const handleBaseError = e => ({
  type: 'base',
  reason: ErrorReason.UNKNOWN,
  origin: e
});

const handleHTTPError = e => {
  const status = e.response.status;
  let reason = ErrorReason.HTTP_OTHER;

  if (status >= 400 && status < 500) {
    reason = ErrorReason.HTTP_CLIENT;
  }

  if (status >= 500) {
    reason = ErrorReason.HTTP_SERVER;
  }

  return {
    type: 'http',
    reason,
    status,
    origin: e
  };
};

const errorHandler = e => {
  if (e instanceof HTTPError) return handleHTTPError(e);
  return handleBaseError(e);
};
const isHandledError = e => e && e.type && e.reason;
const isHTTPError = e => isHandledError(e) && e.type === 'http';

function formDataFromFile(file) {
  const data = new FormData();
  data.append('file', file);
  return data;
}

function createGuard(type) {
  return function (typed) {
    if (!typed.type) return false;
    return type.includes(typed.type);
  };
}

const isLayer = /*#__PURE__*/createGuard(['PostgresLayerService', 'PostgresTileLayerService']);

const addSubDomainToLocation = subDomain => window.location.protocol + "//" + subDomain + "." + window.location.host;

const ALPHABET = 'abcdefghijklmnopqrstuvwxyz0123456789';
/** Generates unique identifier */

const generateId = /*#__PURE__*/customAlphabet(ALPHABET, 12);

const stripUselessSlashes = function stripUselessSlashes() {
  for (var _len = arguments.length, strings = new Array(_len), _key = 0; _key < _len; _key++) {
    strings[_key] = arguments[_key];
  }

  return strings.join('/').split('/').filter(Boolean).join('/');
};

const RESOURCE_TEMP_WORKSPACE = 'temp';
var ResourceSeparator;

(function (ResourceSeparator) {
  ResourceSeparator["Server"] = ".";
})(ResourceSeparator || (ResourceSeparator = {}));

let Names = /*#__PURE__*/function () {
  function Names(_ref) {
    let {
      account
    } = _ref;

    _classCallCheck(this, Names);

    this.account = account;
  }
  /** Generates unique identifier */


  _createClass(Names, [{
    key: "createId",
    value: function createId() {
      return generateId();
    }
    /** Generates new resource name using for client\server interactions */

  }, {
    key: "createResourceName",
    value: function createResourceName(params) {
      if (params === void 0) {
        params = {};
      }

      const workspace = params.workspace || this.account.user && this.account.user.namespace || '';
      const name = params.name || this.createId();
      const separator = params.separator || ResourceSeparator.Server;

      if (!workspace) {
        console.warn('Resource should have workspace. Check account api');
      }

      return "" + workspace + separator + name;
    }
    /** Generates temporary resource name using for client\server interactions */

  }, {
    key: "createTempResourceName",
    value: function createTempResourceName(params) {
      if (params === void 0) {
        params = {};
      }

      return this.createResourceName(_extends({
        workspace: RESOURCE_TEMP_WORKSPACE
      }, params));
    }
    /** Extract resource information (workspace, name) */

  }, {
    key: "extractResource",
    value: function extractResource(resourceName) {
      if (resourceName) {
        if (resourceName.includes(ResourceSeparator.Server)) {
          const matches = resourceName.split(ResourceSeparator.Server);
          const name = matches.pop();
          const workspace = matches.join(ResourceSeparator.Server);
          return {
            workspace,
            name
          };
        }
      }

      return {
        name: '',
        workspace: ''
      };
    }
    /** Extract resource name */

  }, {
    key: "extractResourceName",
    value: function extractResourceName(resourceName) {
      return this.extractResource(resourceName).name || resourceName || '';
    }
    /** Extract resource workspace */

  }, {
    key: "extractResourceWorkspace",
    value: function extractResourceWorkspace(resourceName) {
      return this.extractResource(resourceName).workspace || '';
    }
  }]);

  return Names;
}();

/**
 * @title Spatial Processing Core API
 * @version 1.0.0
 * @baseUrl /sp
 */

let IceRouterService = /*#__PURE__*/function (_Service) {
  _inherits(IceRouterService, _Service);

  var _super = /*#__PURE__*/_createSuper(IceRouterService);

  function IceRouterService() {
    _classCallCheck(this, IceRouterService);

    return _super.apply(this, arguments);
  }

  _createClass(IceRouterService, [{
    key: "startTask",
    value:
    /**
     * No description
     *
     * @tags IceRouter
     * @name StartTask
     * @operationId IceRouterController_StartTask
     * @summary Start route build between start and end points.
     * @request POST:/ice-router/tasks
     * @response `200` Success
     */
    function startTask(data) {
      return this.http.post("/ice-router/tasks", data).text();
    }
    /**
     * No description
     *
     * @tags IceRouter
     * @name GetResult
     * @operationId IceRouterController_GetResult
     * @summary Get task result.
     * @request GET:/ice-router/tasks/{id}
     * @response `200` Success
     */

  }, {
    key: "getResult",
    value: function getResult(id) {
      return this.http.get("/ice-router/tasks/" + id).json();
    }
  }]);

  return IceRouterService;
}(Service);

let IceRouter = /*#__PURE__*/function (_IceRouterService) {
  _inherits(IceRouter, _IceRouterService);

  var _super = /*#__PURE__*/_createSuper(IceRouter);

  function IceRouter() {
    _classCallCheck(this, IceRouter);

    return _super.apply(this, arguments);
  }

  return _createClass(IceRouter);
}(IceRouterService);

/**
 * @title Spatial Processing Core API
 * @version 1.0.0
 * @baseUrl /sp
 */

let StatisticService = /*#__PURE__*/function (_Service) {
  _inherits(StatisticService, _Service);

  var _super = /*#__PURE__*/_createSuper(StatisticService);

  function StatisticService() {
    _classCallCheck(this, StatisticService);

    return _super.apply(this, arguments);
  }

  _createClass(StatisticService, [{
    key: "statisticsDb",
    value:
    /**
     * No description
     *
     * @tags Statistic
     * @name StatisticsDb
     * @operationId StatisticController_StatisticsDb
     * @summary Calculates statistics for layer attribute.
     * @request GET:/statistics
     * @response `200` Success
     */
    function statisticsDb(query) {
      return this.http.get("/statistics", query).json();
    }
    /**
     * No description
     *
     * @tags Statistic
     * @name Classify
     * @operationId StatisticController_Classify
     * @summary Returns the classified attribute values that correspond to the given number of classes and given condition.
     * @request GET:/statistics/classify
     * @response `200` Success
     */

  }, {
    key: "classify",
    value: function classify(query) {
      return this.http.get("/statistics/classify", query).json();
    }
    /**
     * No description
     *
     * @tags Statistic
     * @name SumOfProduct
     * @operationId StatisticController_SumOfProduct
     * @summary Sum of product.
     * @request GET:/statistics/sumOfProduct
     * @response `200` Success
     */

  }, {
    key: "sumOfProduct",
    value: function sumOfProduct(query) {
      return this.http.get("/statistics/sumOfProduct", query).json();
    }
  }]);

  return StatisticService;
}(Service);

let Statistic = /*#__PURE__*/function (_StatisticService) {
  _inherits(Statistic, _StatisticService);

  var _super = /*#__PURE__*/_createSuper(Statistic);

  function Statistic() {
    _classCallCheck(this, Statistic);

    return _super.apply(this, arguments);
  }

  _createClass(Statistic, [{
    key: "getStatistic",
    value: function getStatistic(params) {
      return this.statisticsDb(params);
    }
  }, {
    key: "getClassify",
    value: function getClassify(params) {
      return this.classify(params);
    }
  }]);

  return Statistic;
}(StatisticService);

/**
 * @title Spatial Processing Core API
 * @version 1.0.0
 * @baseUrl /sp
 */

let FeedbackService = /*#__PURE__*/function (_Service) {
  _inherits(FeedbackService, _Service);

  var _super = /*#__PURE__*/_createSuper(FeedbackService);

  function FeedbackService() {
    _classCallCheck(this, FeedbackService);

    return _super.apply(this, arguments);
  }

  _createClass(FeedbackService, [{
    key: "increaseResourcesLimit",
    value:
    /**
     * No description
     *
     * @tags Feedback
     * @name IncreaseResourcesLimit
     * @operationId FeedbackController_IncreaseResourcesLimit
     * @summary Increase resources limit request.
     * @request POST:/feedback/limits
     * @response `200` Success
     */
    function increaseResourcesLimit(query) {
      return this.http.post("/feedback/limits", null, query).json();
    }
    /**
     * No description
     *
     * @tags Feedback
     * @name MoreSymbols
     * @operationId FeedbackController_MoreSymbols
     * @summary More symbols request.
     * @request POST:/feedback/symbol
     * @response `200` Success
     */

  }, {
    key: "moreSymbols",
    value: function moreSymbols(query) {
      return this.http.post("/feedback/symbol", null, query).json();
    }
    /**
     * No description
     *
     * @tags Feedback
     * @name Feedback
     * @operationId FeedbackController_Feedback
     * @summary Feedback request.
     * @request POST:/feedback
     * @response `200` Success
     */

  }, {
    key: "feedback",
    value: function feedback(query, data) {
      return this.http.post("/feedback", toFormData(data), query).json();
    }
  }]);

  return FeedbackService;
}(Service);

let Feedback = /*#__PURE__*/function (_FeedbackService) {
  _inherits(Feedback, _FeedbackService);

  var _super = /*#__PURE__*/_createSuper(Feedback);

  function Feedback() {
    _classCallCheck(this, Feedback);

    return _super.apply(this, arguments);
  }

  _createClass(Feedback, [{
    key: "postFeedback",
    value: function postFeedback(query, data) {
      return this.feedback(query, data);
    }
  }]);

  return Feedback;
}(FeedbackService);

const _excluded$6 = ["name", "z", "x", "y"];
/**
 * @title Spatial Processing Core API
 * @version 1.0.0
 * @baseUrl /sp
 */

let VectorTileService = /*#__PURE__*/function (_Service) {
  _inherits(VectorTileService, _Service);

  var _super = /*#__PURE__*/_createSuper(VectorTileService);

  function VectorTileService() {
    _classCallCheck(this, VectorTileService);

    return _super.apply(this, arguments);
  }

  _createClass(VectorTileService, [{
    key: "getVectorTile",
    value:
    /**
     * No description
     *
     * @tags VectorTileService
     * @name GetVectorTile
     * @operationId VectorTileServiceController_GetVectorTile
     * @summary Get vector tile from visible project layers or single layer.
     * @request GET:/vt/{name}/{z}/{x}/{y}.pbf
     * @response `200` Success
     */
    function getVectorTile(_ref) {
      let {
        name,
        z,
        x,
        y
      } = _ref,
          query = _objectWithoutPropertiesLoose(_ref, _excluded$6);

      return this.http.get("/vt/" + name + "/" + z + "/" + x + "/" + y + ".pbf", query).then(() => {});
    }
  }]);

  return VectorTileService;
}(Service);

let VectorTiles = /*#__PURE__*/function (_VectorTileService) {
  _inherits(VectorTiles, _VectorTileService);

  var _super = /*#__PURE__*/_createSuper(VectorTiles);

  function VectorTiles() {
    _classCallCheck(this, VectorTiles);

    return _super.apply(this, arguments);
  }

  _createClass(VectorTiles, [{
    key: "getVt",
    value: function getVt(name, z, x, y, isProject) {
      return this.getVectorTile({
        name,
        z,
        x,
        y,
        isProject
      });
    }
  }]);

  return VectorTiles;
}(VectorTileService);

/**
 * @title Spatial Processing Core API
 * @version 1.0.0
 * @baseUrl /sp
 */

let PrintService = /*#__PURE__*/function (_Service) {
  _inherits(PrintService, _Service);

  var _super = /*#__PURE__*/_createSuper(PrintService);

  function PrintService() {
    _classCallCheck(this, PrintService);

    return _super.apply(this, arguments);
  }

  _createClass(PrintService, [{
    key: "print",
    value:
    /**
     * No description
     *
     * @tags Print
     * @name Print
     * @operationId PrintController_Print
     * @summary Print map with template.
     * @request POST:/print/print
     * @response `200` Success
     */
    function print(data) {
      return this.http.post("/print/print", data).blob();
    }
    /**
     * No description
     *
     * @tags Print
     * @name PrintToHtml
     * @operationId PrintController_PrintToHtml
     * @summary Print map with template to html string.
     * @request POST:/print/printHtml
     * @response `200` Success
     */

  }, {
    key: "printToHtml",
    value: function printToHtml(data) {
      return this.http.post("/print/printHtml", data).text();
    }
    /**
     * No description
     *
     * @tags Print
     * @name UploadTemplate
     * @operationId PrintController_UploadTemplate
     * @summary Upload template on server.
     * @request POST:/print/templates
     * @response `200` Success
     */

  }, {
    key: "uploadTemplate",
    value: function uploadTemplate(query, data) {
      return this.http.post("/print/templates", toFormData(data), query).then(() => {});
    }
    /**
     * No description
     *
     * @tags Print
     * @name GetTemplates
     * @operationId PrintController_GetTemplates
     * @summary Get all templates from server.
     * @request GET:/print/templates
     * @response `200` Success
     */

  }, {
    key: "getTemplates",
    value: function getTemplates() {
      return this.http.get("/print/templates").json();
    }
    /**
     * No description
     *
     * @tags Print
     * @name DeleteTemplate
     * @operationId PrintController_DeleteTemplate
     * @summary Delete template from server.
     * @request DELETE:/print/templates/{name}
     * @response `200` Success
     */

  }, {
    key: "deleteTemplate",
    value: function deleteTemplate(name) {
      return this.http.delete("/print/templates/" + name, null).then(() => {});
    }
    /**
     * No description
     *
     * @tags Print
     * @name GetTemplate
     * @operationId PrintController_GetTemplate
     * @summary Get template from server.
     * @request GET:/print/templates/{name}
     * @response `200` Success
     */

  }, {
    key: "getTemplate",
    value: function getTemplate(name) {
      return this.http.get("/print/templates/" + name).text();
    }
  }]);

  return PrintService;
}(Service);

let Print = /*#__PURE__*/function (_PrintService) {
  _inherits(Print, _PrintService);

  var _super = /*#__PURE__*/_createSuper(Print);

  function Print() {
    _classCallCheck(this, Print);

    return _super.apply(this, arguments);
  }

  return _createClass(Print);
}(PrintService);

var UrlPath;

(function (UrlPath) {
  UrlPath["Base"] = "/map";
  UrlPath["Shared"] = "/shared";
  UrlPath["Portal"] = "/portal";
})(UrlPath || (UrlPath = {}));

const apiEventsByResponseStatus = {
  401: ApiEvent.Unauthorized
};
const URL_PATHS = /*#__PURE__*/Object.values(UrlPath);
const DEFAULT_URL_PATH = URL_PATHS[0];
let Api = /*#__PURE__*/function (_EventEmitter) {
  _inherits(Api, _EventEmitter);

  var _super = /*#__PURE__*/_createSuper(Api);

  function Api(_ref) {
    var _this;

    let {
      url,
      wsUrl,
      wsKeepAlive,
      snappingHubUrl,
      http,
      urlPath,
      httpOptions
    } = _ref;

    _classCallCheck(this, Api);

    _this = _super.call(this);
    const {
      hooks
    } = httpOptions || {};
    _this.http = http || new HttpClient(_extends({
      prefixUrl: url,
      timeout: false
    }, httpOptions || {}, {
      hooks: _extends({}, hooks || {}, {
        beforeRequest: [...(hooks && hooks.beforeRequest || [])],
        afterResponse: [response => {
          const apiEvent = apiEventsByResponseStatus[response.status];

          if (apiEvent) {
            _this.emit(apiEvent, errorHandler(new HTTPError(response)));
          }

          return response;
        }, ...(hooks && hooks.afterResponse || [])]
      })
    }));
    _this.url = url;
    _this.wsUrl = wsUrl || url;
    _this.urlPath = urlPath || _this.defineUrlPath();
    _this.layers = new Layers(_this.http);
    _this.tables = new Tables(_this.http);
    _this.projects = new Projects(_this.http);
    _this.resources = new Resources(_this.projects, _this.layers, _this.tables);
    _this.styles = new Styles(_this.http);
    _this.account = new Account(_this.http);
    _this.accountPreview = new AccountPreview(_this.http, _this.account);
    _this.bulk = new BulkOperations(_this.http);
    _this.security = new Security(_this.http, _this.account);
    _this.notification = new Notification(_this.http, _assertThisInitialized(_this), wsKeepAlive);
    _this.scheduler = new Scheduler(_this.http);
    _this.file = new FileUpload(_this.http);
    _this.filters = new Filters(_this.http);
    _this.import = new Import(_this.http);
    _this.geocode = new Geocode(_this.http);
    _this.print = new Print(_this.http);
    _this.tools = new Tools(_this.http);
    _this.resourceCatalog = new ResourceCatalog(_this.http);
    _this.general = new General(_this.http);
    _this.namespace = new Namespace(_this.http);
    _this.external = new External(_this.http);
    _this.clientSettings = new ClientSettings(_this.http);
    _this.portalSettings = new PortalSettings(_this.http);
    _this.iceRouter = new IceRouter(_this.http);
    _this.statistic = new Statistic(_this.http);
    _this.feedback = new Feedback(_this.http);
    _this.vectorTiles = new VectorTiles(_this.http);
    _this.universalSearch = new UniversalSearchService(_this.http);
    _this.names = new Names({
      account: _this.account
    });
    _this.snappingHub = snappingHubUrl ? new HubConnectionBuilder().withUrl(snappingHubUrl, {
      withCredentials: true,
      skipNegotiation: true,
      transport: HttpTransportType.WebSockets
    }).withAutomaticReconnect().build() : null;
    return _this;
  }

  _createClass(Api, [{
    key: "init",
    value: async function init(_ref2) {
      let {
        authParams,
        connectWs,
        initScheduler,
        fetchSettings,
        fetchUser
      } = _ref2;

      try {
        await this.account.login(authParams);

        if (fetchUser) {
          await this.account.fetchCurrentUser();
        }

        if (connectWs) {
          await this.connectWs();
        }

        if (initScheduler) {
          await this.initScheduler();
        }

        if (fetchSettings) {
          await this.clientSettings.fetchClientSettings({
            urlPath: this.urlPath
          });
        }

        await this.notification.subscribe("service_update"
        /* ServiceUpdate */
        );
      } catch (e) {
        throw errorHandler(e);
      }
    }
  }, {
    key: "isAcceptedNetwork",
    value: function isAcceptedNetwork(network) {
      return ['vk', 'google', 'facebook'].includes(network);
    }
  }, {
    key: "socAuthLogin",
    value: async function socAuthLogin(network) {
      if (!this.isAcceptedNetwork(network)) return;

      try {
        await this.clientSettings.fetchClientSettings({
          urlPath: UrlPath.Base
        });
      } catch (e) {
        throw errorHandler(e);
      }
    }
  }, {
    key: "connectWs",
    value: async function connectWs() {
      if (this.account.isAuth) {
        this.notification.connectWs(this.wsUrl);
        this.notification.on("ConnectionStatus"
        /* ConnectionStatus */
        , connection => {
          if (connection.data === ConnectionStatus.Lost) {
            this.emit(ApiEvent.ConnectionLost, connection.data);
          } else if (connection.data === ConnectionStatus.SessionClosed) {
            this.emit(ApiEvent.SessionClosed, connection.data);
          }
        });
      }
    }
  }, {
    key: "connectSignalR",
    value: async function connectSignalR() {
      if (this.account.isAuth && this.snappingHub && this.snappingHub.state !== HubConnectionState.Connected) {
        await this.snappingHub.start();
      }
    }
  }, {
    key: "logout",
    value: async function logout() {
      await this.account.logout();
      await this.security.reset();
      this.emit(ApiEvent.Unauthorized, null);
    }
  }, {
    key: "initScheduler",
    value: function initScheduler() {
      return this.scheduler.init(this.notification);
    }
  }, {
    key: "defineUrlPath",
    value: function defineUrlPath() {
      const firstPath = (window.location.href.split(window.location.hostname)[1] || '').split('/').filter(Boolean)[0];
      const urlPath = firstPath ? "/" + firstPath : void 0;
      return urlPath && URL_PATHS.includes(urlPath) ? urlPath : DEFAULT_URL_PATH;
    }
  }, {
    key: "isShared",
    get: function get() {
      return this.urlPath === UrlPath.Shared;
    }
  }]);

  return Api;
}(EventEmitter);

function generateRandom(min, max) {
  if (min === void 0) {
    min = 0;
  }

  if (max === void 0) {
    max = 100;
  }

  let difference = max - min;
  let rand = Math.random();
  rand = Math.floor(rand * difference);
  rand = rand + min;
  return rand;
}

let EvergisTileLayer = /*#__PURE__*/function (_TileLayer) {
  _inherits(EvergisTileLayer, _TileLayer);

  var _super = /*#__PURE__*/_createSuper(EvergisTileLayer);

  function EvergisTileLayer(configuration, api) {
    var _this;

    _classCallCheck(this, EvergisTileLayer);

    _this = _super.call(this, '', {
      crs: configuration.crs,
      opacity: configuration.opacity
    });
    _this.api = api;
    _this.name = configuration.name;
    _this.sourceUrl = configuration.sourceUrl;
    _this.subDomains = configuration.subDomains;
    return _this;
  }

  _createClass(EvergisTileLayer, [{
    key: "getTileUrl",
    value: function getTileUrl(x, y, level) {
      var _this$subDomains;

      const name = this.name;
      const subDomainIndex = this.subDomains ? generateRandom(0, ((_this$subDomains = this.subDomains) == null ? void 0 : _this$subDomains.length) - 1) : undefined;
      return this.sourceUrl ? (this.subDomains && subDomainIndex !== undefined ? this.sourceUrl.replace("{0}", this.subDomains[subDomainIndex]) : this.sourceUrl).replace("{1}", "" + level).replace("{2}", "" + x).replace("{3}", "" + y) : this.api.layers.getTilesLayerImage({
        x,
        y,
        z: level,
        name
      });
    }
  }]);

  return EvergisTileLayer;
}(TileLayer);

const _excluded$7 = ["name", "style", "condition", "dataFilterId"];
let EvergisDynamicLayer = /*#__PURE__*/function (_DynamicLayer) {
  _inherits(EvergisDynamicLayer, _DynamicLayer);

  var _super = /*#__PURE__*/_createSuper(EvergisDynamicLayer);

  function EvergisDynamicLayer(_ref, api) {
    var _this;

    let {
      name,
      style,
      condition,
      dataFilterId
    } = _ref,
        layerProps = _objectWithoutPropertiesLoose(_ref, _excluded$7);

    _classCallCheck(this, EvergisDynamicLayer);

    _this = _super.call(this, layerProps);
    _this.api = api;
    _this.name = name;
    _this.styleId = style;
    _this.conditionQuery = condition;
    _this.filterId = dataFilterId;

    _this.subscribeRedraw();

    return _this;
  } // @ts-ignore TODO


  _createClass(EvergisDynamicLayer, [{
    key: "style",
    get: // @ts-ignore TODO
    function get() {
      return this.styleId;
    } // @ts-ignore TODO
    ,
    set: function set(styleId) {
      this.styleId = styleId;
      this.forceUpdate();
    }
  }, {
    key: "condition",
    get: // @ts-ignore TODO
    function get() {
      return this.conditionQuery;
    } // @ts-ignore TODO
    ,
    set: function set(condition) {
      this.conditionQuery = condition;
      this.forceUpdate();
    }
  }, {
    key: "dataFilterId",
    get: // @ts-ignore TODO
    function get() {
      return this.filterId;
    },
    set: function set(filterId) {
      this.filterId = filterId;
      this.forceUpdate();
    }
  }, {
    key: "getUrl",
    value: function getUrl(bbox, resolution) {
      let imgWidth = Math.round((bbox.xMax - bbox.xMin) / resolution);
      let imgHeight = Math.round((bbox.yMax - bbox.yMin) / resolution);
      return this.api.layers.getLayerImage({
        name: this.name,
        extent: bbox.coordinates,
        size: [imgWidth, imgHeight],
        extentSr: bbox.crs.wkid,
        styleId: this.styleId,
        condition: this.conditionQuery,
        dataFilterId: this.filterId
      });
    }
  }, {
    key: "subscribeRedraw",
    value: function subscribeRedraw() {
      this.api.notification.on("service_update"
      /* ServiceUpdate */
      , e => {
        if ((e == null ? void 0 : e.data.layerName) === this.name) {
          this.forceUpdate();
          this.redraw();
        }
      });
    }
  }]);

  return EvergisDynamicLayer;
}(DynamicLayer);

const LayerServicesMap = {
  RemoteTileService: EvergisTileLayer,
  LocalTileService: EvergisTileLayer,
  PostgresLayerService: EvergisDynamicLayer,
  StyledFeatureLayer: EvergisDynamicLayer,
  CompositeService: null
};

const isLayerType = type => Boolean(type && Object.keys(LayerServicesMap).includes(type));

const withServicesPrefix = layerInfo => _extends({}, layerInfo, {
  name: "services/" + layerInfo.name
});

let LayersManager = /*#__PURE__*/function () {
  function LayersManager(layers, http) {
    _classCallCheck(this, LayersManager);

    this.layers = layers;
    this.http = http;
  }

  _createClass(LayersManager, [{
    key: "getLayerService",
    value: async function getLayerService(name) {
      let layerInfo = await this.getLayerInfo(name);
      const type = layerInfo.type;

      if (!isLayerType(type)) {
        return;
      }

      const ServiceCtor = LayerServicesMap[type];

      if (ServiceCtor) {
        // @ts-ignore
        return new ServiceCtor(withServicesPrefix(layerInfo), this.http);
      } else {
        throw new Error("Constructor for service type: \"" + layerInfo.type + "\" not implemented");
      }
    }
  }, {
    key: "getLayerInfo",
    value: async function getLayerInfo(name) {
      try {
        return await this.layers.getLayerInfo(name);
      } catch (_unused) {
        throw new Error("Service with name: \"" + name + "\" not exists");
      }
    }
  }]);

  return LayersManager;
}();

var LayersZIndex;

(function (LayersZIndex) {
  LayersZIndex[LayersZIndex["BaseMaps"] = 0] = "BaseMaps";
  LayersZIndex[LayersZIndex["Layers"] = 1] = "Layers";
})(LayersZIndex || (LayersZIndex = {}));

let SpatialProcessor = /*#__PURE__*/function (_Api) {
  _inherits(SpatialProcessor, _Api);

  var _super = /*#__PURE__*/_createSuper(SpatialProcessor);

  function SpatialProcessor(mapProps, apiParams, authParams) {
    var _this;

    _classCallCheck(this, SpatialProcessor);

    _this = _super.call(this, apiParams);
    _this.map = new Map();
    _this.painter = new DomPainter(_this.map);
    _this.mapProps = mapProps;
    _this.auth = authParams;
    _this.layersManager = new LayersManager(_this.layers, _this.http);
    return _this;
  }

  _createClass(SpatialProcessor, [{
    key: "init",
    value: async function init() {
      await _get(_getPrototypeOf(SpatialProcessor.prototype), "init", this).call(this, {
        authParams: this.auth,
        connectWs: true,
        fetchSettings: true,
        initScheduler: true
      });
      const {
        baseService,
        services,
        projectName
      } = this.mapProps;

      if (baseService) {
        await this.setBaseMap(baseService);
      }

      if (services) {
        await Promise.all(services.map(service => this.addLayer(service)));
      }

      if (projectName) {
        await this.loadProject(projectName);
      }

      this.setMapProps();
    }
  }, {
    key: "reset",
    value: async function reset() {
      await this.account.logout();
      this.painter.wrapper = null;
    }
  }, {
    key: "addLayer",
    value: async function addLayer(name) {
      await this.insertLayer(name, LayersZIndex.Layers);
    }
  }, {
    key: "setBaseMap",
    value: async function setBaseMap(name) {
      await this.insertLayer(name, LayersZIndex.BaseMaps);
    }
  }, {
    key: "loadProject",
    value: async function loadProject(name) {
      const projectInfo = await this.projects.getProjectInfo(name);

      if (!(projectInfo && projectInfo.content)) {
        return;
      }

      const {
        baseMapName,
        items
      } = projectInfo.content;

      if (baseMapName) {
        await this.setBaseMap(baseMapName);
      }

      if (items) {
        const layers = items.map(item => item.name).filter(isString$1);
        await Promise.all(layers.map(layer => this.addLayer(layer)));
      }
    }
  }, {
    key: "insertLayer",
    value: async function insertLayer(name, index) {
      const service = await this.layersManager.getLayerService(name);

      if (service) {
        // @ts-ignore
        this.map.insertLayer(service.layer, index);
      }
    }
  }, {
    key: "setMapProps",
    value: function setMapProps() {
      const {
        position,
        centerPoint,
        mapWrapper,
        resolution
      } = this.mapProps;

      if (position) {
        this.map.position = position;
      } else if (centerPoint) {
        this.map.centerPoint = centerPoint;
      }

      if (resolution) this.map.resolution = resolution;
      if (mapWrapper) this.painter.wrapper = mapWrapper;
    }
  }]);

  return SpatialProcessor;
}(Api);

const isString$1 = s => s !== undefined;

function isEvergisDynamicLayer(layer) {
  return layer instanceof EvergisDynamicLayer;
}
function isEvergisTileLayer(layer) {
  return layer instanceof EvergisTileLayer;
}
function isFeatureLayer(layer) {
  return layer instanceof FeatureLayer;
}

/* eslint-disable */

/* tslint:disable */

/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
*

None

Array

Min

Max

Avg

Sum

Extent

H3

Count

TotalCount

DistinctCount

First

Last

Median

Mod

StdDeviation

SumOfProduct

OnlyValue

WeightedAvg

DensityIndicators

DividedSum
*/
var AggregationFunction;

(function (AggregationFunction) {
  AggregationFunction["None"] = "None";
  AggregationFunction["Array"] = "Array";
  AggregationFunction["Min"] = "Min";
  AggregationFunction["Max"] = "Max";
  AggregationFunction["Avg"] = "Avg";
  AggregationFunction["Sum"] = "Sum";
  AggregationFunction["Extent"] = "Extent";
  AggregationFunction["H3"] = "H3";
  AggregationFunction["Count"] = "Count";
  AggregationFunction["TotalCount"] = "TotalCount";
  AggregationFunction["DistinctCount"] = "DistinctCount";
  AggregationFunction["First"] = "First";
  AggregationFunction["Last"] = "Last";
  AggregationFunction["Median"] = "Median";
  AggregationFunction["Mod"] = "Mod";
  AggregationFunction["StdDeviation"] = "StdDeviation";
  AggregationFunction["SumOfProduct"] = "SumOfProduct";
  AggregationFunction["OnlyValue"] = "OnlyValue";
  AggregationFunction["WeightedAvg"] = "WeightedAvg";
  AggregationFunction["DensityIndicators"] = "DensityIndicators";
  AggregationFunction["DividedSum"] = "DividedSum";
})(AggregationFunction || (AggregationFunction = {}));
/**
* Types of the attributes that are supported by the system.

Unknown

String

Int32

Int64

Double

DateTime

Boolean

Point

Polyline

Polygon

Multipoint

H3Index
*/


var AttributeType;

(function (AttributeType) {
  AttributeType["Unknown"] = "Unknown";
  AttributeType["String"] = "String";
  AttributeType["Int32"] = "Int32";
  AttributeType["Int64"] = "Int64";
  AttributeType["Double"] = "Double";
  AttributeType["DateTime"] = "DateTime";
  AttributeType["Boolean"] = "Boolean";
  AttributeType["Point"] = "Point";
  AttributeType["Polyline"] = "Polyline";
  AttributeType["MultiPolygon"] = "Polygon";
  AttributeType["Multipoint"] = "Multipoint";
  AttributeType["H3Index"] = "H3Index";
})(AttributeType || (AttributeType = {}));
/**
* Describes classification methods.

none

naturalBreaks

equalInterval

quantile

unique
*/


var ClassificationType;

(function (ClassificationType) {
  ClassificationType["None"] = "none";
  ClassificationType["NaturalBreaks"] = "naturalBreaks";
  ClassificationType["EqualInterval"] = "equalInterval";
  ClassificationType["Quantile"] = "quantile";
  ClassificationType["Unique"] = "unique";
})(ClassificationType || (ClassificationType = {}));
/**
* Type of attribute.

decimal

dateTime

text
*/


var ClassifyAttributeType;

(function (ClassifyAttributeType) {
  ClassifyAttributeType["Decimal"] = "decimal";
  ClassifyAttributeType["DateTime"] = "dateTime";
  ClassifyAttributeType["Text"] = "text";
})(ClassifyAttributeType || (ClassifyAttributeType = {}));
/**
* Types of errors that can occur during layer initialize.

Unknown

SerializeError

InvalidDataService

InvalidConfiguration

InvalidDataServiceName

InvalidTableName

InvalidLayerName

ResourceNotFound

InvalidCondition

InvalidAttributes

InvalidIdAttribute

InvalidGeometryAttribute

InvalidGeometryAttributeType

InvalidColumnName

InvalidIdColumnSettings

ColumnNotExistsInTable

InvalidStyle

InvalidLayerType

ColumnLoadingError

InvalidAttributeFormat

DataSourceNotFound

DuplicateColumns

DuplicateAttributes

TableWithoutColumns

InvalidTableReferenceConfiguration
*/


var ConfigurationErrorEnum;

(function (ConfigurationErrorEnum) {
  ConfigurationErrorEnum["Unknown"] = "Unknown";
  ConfigurationErrorEnum["SerializeError"] = "SerializeError";
  ConfigurationErrorEnum["InvalidDataService"] = "InvalidDataService";
  ConfigurationErrorEnum["InvalidConfiguration"] = "InvalidConfiguration";
  ConfigurationErrorEnum["InvalidDataServiceName"] = "InvalidDataServiceName";
  ConfigurationErrorEnum["InvalidTableName"] = "InvalidTableName";
  ConfigurationErrorEnum["InvalidLayerName"] = "InvalidLayerName";
  ConfigurationErrorEnum["ResourceNotFound"] = "ResourceNotFound";
  ConfigurationErrorEnum["InvalidCondition"] = "InvalidCondition";
  ConfigurationErrorEnum["InvalidAttributes"] = "InvalidAttributes";
  ConfigurationErrorEnum["InvalidIdAttribute"] = "InvalidIdAttribute";
  ConfigurationErrorEnum["InvalidGeometryAttribute"] = "InvalidGeometryAttribute";
  ConfigurationErrorEnum["InvalidGeometryAttributeType"] = "InvalidGeometryAttributeType";
  ConfigurationErrorEnum["InvalidColumnName"] = "InvalidColumnName";
  ConfigurationErrorEnum["InvalidIdColumnSettings"] = "InvalidIdColumnSettings";
  ConfigurationErrorEnum["ColumnNotExistsInTable"] = "ColumnNotExistsInTable";
  ConfigurationErrorEnum["InvalidStyle"] = "InvalidStyle";
  ConfigurationErrorEnum["InvalidLayerType"] = "InvalidLayerType";
  ConfigurationErrorEnum["ColumnLoadingError"] = "ColumnLoadingError";
  ConfigurationErrorEnum["InvalidAttributeFormat"] = "InvalidAttributeFormat";
  ConfigurationErrorEnum["DataSourceNotFound"] = "DataSourceNotFound";
  ConfigurationErrorEnum["DuplicateColumns"] = "DuplicateColumns";
  ConfigurationErrorEnum["DuplicateAttributes"] = "DuplicateAttributes";
  ConfigurationErrorEnum["TableWithoutColumns"] = "TableWithoutColumns";
  ConfigurationErrorEnum["InvalidTableReferenceConfiguration"] = "InvalidTableReferenceConfiguration";
})(ConfigurationErrorEnum || (ConfigurationErrorEnum = {}));
/**
* Type of the error.

ResourceLimitExceeded

ResourceNotFound

InternalError

BadRequest

DuplicateContent
*/


var ErrorDetailsType;

(function (ErrorDetailsType) {
  ErrorDetailsType["ResourceLimitExceeded"] = "ResourceLimitExceeded";
  ErrorDetailsType["ResourceNotFound"] = "ResourceNotFound";
  ErrorDetailsType["InternalError"] = "InternalError";
  ErrorDetailsType["BadRequest"] = "BadRequest";
  ErrorDetailsType["DuplicateContent"] = "DuplicateContent";
})(ErrorDetailsType || (ErrorDetailsType = {}));

var ErrorType;

(function (ErrorType) {
  ErrorType["NotSpecified"] = "NotSpecified";
  ErrorType["LimitError"] = "LimitError";
  ErrorType["ValidationError"] = "ValidationError";
  ErrorType["JwtExpired"] = "JwtExpired";
  ErrorType["TokenInvalid"] = "TokenInvalid";
  ErrorType["RefreshTokenExpired"] = "RefreshTokenExpired";
  ErrorType["RefreshTokenInvalid"] = "RefreshTokenInvalid";
  ErrorType["CreateUserFailed"] = "CreateUserFailed";
  ErrorType["SetUserPasswordFailed"] = "SetUserPasswordFailed";
  ErrorType["SetUserRoleFailed"] = "SetUserRoleFailed";
  ErrorType["UpdateUserFailed"] = "UpdateUserFailed";
  ErrorType["RemoveUserFailed"] = "RemoveUserFailed";
  ErrorType["CreateRoleFailed"] = "CreateRoleFailed";
  ErrorType["UpdateRoleFailed"] = "UpdateRoleFailed";
  ErrorType["RemoveUserRoleFailed"] = "RemoveUserRoleFailed";
  ErrorType["ChangeActiveStateFailed"] = "ChangeActiveStateFailed";
  ErrorType["RemoveRoleFailed"] = "RemoveRoleFailed";
  ErrorType["UserNotFound"] = "UserNotFound";
  ErrorType["RoleNotFound"] = "RoleNotFound";
  ErrorType["EmailNotConfirmed"] = "EmailNotConfirmed";
  ErrorType["DuplicateEmailError"] = "DuplicateEmailError";
  ErrorType["InvalidPassword"] = "InvalidPassword";
  ErrorType["RoleExists"] = "RoleExists";
  ErrorType["UserExists"] = "UserExists";
  ErrorType["UserLockedError"] = "UserLockedError";
  ErrorType["InvalidEmail"] = "InvalidEmail";
  ErrorType["InvalidUsername"] = "InvalidUsername";
  ErrorType["Unauthorized"] = "Unauthorized";
  ErrorType["EmailNotChanged"] = "EmailNotChanged";
  ErrorType["EmailNotSet"] = "EmailNotSet";
})(ErrorType || (ErrorType = {}));
/**
* Type of the feature.

Unknown

GeometricFeature
*/


var FeatureType;

(function (FeatureType) {
  FeatureType["Unknown"] = "Unknown";
  FeatureType["GeometricFeature"] = "GeometricFeature";
})(FeatureType || (FeatureType = {}));
/**
* Sets whether font should be styled.

normal

oblique

italic
*/


var FontStyle;

(function (FontStyle) {
  FontStyle["Normal"] = "normal";
  FontStyle["Oblique"] = "oblique";
  FontStyle["Italic"] = "italic";
})(FontStyle || (FontStyle = {}));
/**
* Specifies the weight (or boldness) of the font.

Thin

ExtraLight

Light

SemiLight

Normal

Medium

DemiBold

Bold

ExtraBold

Black

ExtraBlack
*/


var FontWeight;

(function (FontWeight) {
  FontWeight["Thin"] = "Thin";
  FontWeight["ExtraLight"] = "ExtraLight";
  FontWeight["Light"] = "Light";
  FontWeight["SemiLight"] = "SemiLight";
  FontWeight["Normal"] = "Normal";
  FontWeight["Medium"] = "Medium";
  FontWeight["DemiBold"] = "DemiBold";
  FontWeight["Bold"] = "Bold";
  FontWeight["ExtraBold"] = "ExtraBold";
  FontWeight["Black"] = "Black";
  FontWeight["ExtraBlack"] = "ExtraBlack";
})(FontWeight || (FontWeight = {}));
/**
*

unknown

point

polyline

multipolygon

envelope

multipoint
*/


var GeometryType;

(function (GeometryType) {
  GeometryType["Unknown"] = "unknown";
  GeometryType["Point"] = "point";
  GeometryType["Polyline"] = "polyline";
  GeometryType["Polygon"] = "multipolygon";
  GeometryType["Envelope"] = "envelope";
  GeometryType["Multipoint"] = "multipoint";
})(GeometryType || (GeometryType = {}));
/**
* Resource group.

my

role

public

all
*/


var Group;

(function (Group) {
  Group["My"] = "my";
  Group["Role"] = "role";
  Group["Public"] = "public";
  Group["All"] = "all";
})(Group || (Group = {}));
/**
* Specifies the settings of line cap. This is applied to the beginning and end of each non-closed line.

Flat

Square

Round

Triangle
*/


var LineCapStyle;

(function (LineCapStyle) {
  LineCapStyle["Flat"] = "Flat";
  LineCapStyle["Square"] = "Square";
  LineCapStyle["Round"] = "Round";
  LineCapStyle["Triangle"] = "Triangle";
})(LineCapStyle || (LineCapStyle = {}));
/**
* The size of the line ending in a SPCore.Kernel.Rendering.Symbols.SimplePolylineSymbol. The values sent here can be one
of the preset values, or a number representing the size of the ending in pixels for 1px wide lines.

small

large
*/


var LineEndingSize;

(function (LineEndingSize) {
  LineEndingSize["Small"] = "small";
  LineEndingSize["Large"] = "large";
})(LineEndingSize || (LineEndingSize = {}));
/**
* Type of the line ending.

none

arrow

filledArrow

square

filledSquare

circle

filledCircle

svg
*/


var LineEndingType;

(function (LineEndingType) {
  LineEndingType["None"] = "none";
  LineEndingType["Arrow"] = "arrow";
  LineEndingType["FilledArrow"] = "filledArrow";
  LineEndingType["Square"] = "square";
  LineEndingType["FilledSquare"] = "filledSquare";
  LineEndingType["Circle"] = "circle";
  LineEndingType["FilledCircle"] = "filledCircle";
  LineEndingType["Svg"] = "svg";
})(LineEndingType || (LineEndingType = {}));
/**
* Specifies the settings of lines join. This is applied to corners in lines and rectangles.

Miter

Bevel

Round
*/


var LineJoinType;

(function (LineJoinType) {
  LineJoinType["Miter"] = "Miter";
  LineJoinType["Bevel"] = "Bevel";
  LineJoinType["Round"] = "Round";
})(LineJoinType || (LineJoinType = {}));
/**
*

Unknown

union

intersection

subtraction

symDifference
*/


var Operation;

(function (Operation) {
  Operation["Unknown"] = "Unknown";
  Operation["Union"] = "union";
  Operation["Intersection"] = "intersection";
  Operation["Subtraction"] = "subtraction";
  Operation["SymDifference"] = "symDifference";
})(Operation || (Operation = {}));
/**
* User permissions for server security objects (services, projects etc.)

none

configure

write

read

read,configure

read,write

read,write,configure
*/


var Permissions;

(function (Permissions) {
  Permissions["None"] = "none";
  Permissions["Configure"] = "configure";
  Permissions["Write"] = "write";
  Permissions["Read"] = "read";
  Permissions["ReadConfigure"] = "read,configure";
  Permissions["ReadWrite"] = "read,write";
  Permissions["All"] = "read,write,configure";
})(Permissions || (Permissions = {}));
/**
* Type of the authorization policy.

Unknown

CreateTable

CreateLayer

CreateProject

MaxFeaturesInOneTable

MaxObjectsToExport

MaxUploadContentSize
*/


var PolicyType;

(function (PolicyType) {
  PolicyType["Unknown"] = "Unknown";
  PolicyType["CreateTable"] = "CreateTable";
  PolicyType["CreateLayer"] = "CreateLayer";
  PolicyType["CreateProject"] = "CreateProject";
  PolicyType["MaxFeaturesInOneTable"] = "MaxFeaturesInOneTable";
  PolicyType["MaxObjectsToExport"] = "MaxObjectsToExport";
  PolicyType["MaxUploadContentSize"] = "MaxUploadContentSize";
})(PolicyType || (PolicyType = {}));
/**
* Types of table reference.

OneToMany

OneToOne

Intersect
*/


var ReferenceJoinType;

(function (ReferenceJoinType) {
  ReferenceJoinType["OneToMany"] = "OneToMany";
  ReferenceJoinType["OneToOne"] = "OneToOne";
  ReferenceJoinType["Intersect"] = "Intersect";
})(ReferenceJoinType || (ReferenceJoinType = {}));
/**
* The `ResourceType` represents resource manager supports types.

Unknown

table

layer

project

file

feature

tag
*/


var ResourceType;

(function (ResourceType) {
  ResourceType["Unknown"] = "Unknown";
  ResourceType["Table"] = "table";
  ResourceType["Layer"] = "layer";
  ResourceType["Project"] = "project";
  ResourceType["File"] = "file";
  ResourceType["Feature"] = "feature";
  ResourceType["Tag"] = "tag";
})(ResourceType || (ResourceType = {}));

var ResourceTypeLink;

(function (ResourceTypeLink) {
  ResourceTypeLink["Table"] = "tables";
  ResourceTypeLink["Layer"] = "layers";
  ResourceTypeLink["Project"] = "projects";
})(ResourceTypeLink || (ResourceTypeLink = {}));
/**
* Status of the server task.

None

Scheduled

Planning

Executing

Completed

Failed

Canceled

Timeout
*/


var ServerTaskStatus;

(function (ServerTaskStatus) {
  ServerTaskStatus["None"] = "None";
  ServerTaskStatus["Scheduled"] = "Scheduled";
  ServerTaskStatus["Planning"] = "Planning";
  ServerTaskStatus["Executing"] = "Executing";
  ServerTaskStatus["Completed"] = "Completed";
  ServerTaskStatus["Failed"] = "Failed";
  ServerTaskStatus["Canceled"] = "Canceled";
  ServerTaskStatus["Timeout"] = "Timeout";
})(ServerTaskStatus || (ServerTaskStatus = {}));
/**
* Simplify type.

Basic

PreserveTopology

VW
*/


var SimplifyType;

(function (SimplifyType) {
  SimplifyType["Basic"] = "Basic";
  SimplifyType["PreserveTopology"] = "PreserveTopology";
  SimplifyType["VW"] = "VW";
})(SimplifyType || (SimplifyType = {}));
/**
* The `StringSubType` provides information about string attribute subtype.

None

Image

PkkCode
*/


var StringSubType;

(function (StringSubType) {
  StringSubType["None"] = "None";
  StringSubType["Image"] = "Image";
  StringSubType["PkkCode"] = "PkkCode";
})(StringSubType || (StringSubType = {}));
/**
* Task owner group.

my

all
*/


var TaskGroup;

(function (TaskGroup) {
  TaskGroup["My"] = "my";
  TaskGroup["All"] = "all";
})(TaskGroup || (TaskGroup = {}));
/**
* Sets the horizontal alignment of text.

right

left

center

justified
*/


var TextAlignment;

(function (TextAlignment) {
  TextAlignment["Right"] = "right";
  TextAlignment["Left"] = "left";
  TextAlignment["Center"] = "center";
  TextAlignment["Justified"] = "justified";
})(TextAlignment || (TextAlignment = {}));
/**
* Sets the vertical alignment of text.

top

bottom

middle
*/


var TextVerticalAlignment;

(function (TextVerticalAlignment) {
  TextVerticalAlignment["Top"] = "top";
  TextVerticalAlignment["Bottom"] = "bottom";
  TextVerticalAlignment["Middle"] = "middle";
})(TextVerticalAlignment || (TextVerticalAlignment = {}));

export { Account, AccountPreview, AggregationFunction, Api, ApiEvent, AttributeType, BulkOperations, ClassificationType, ClassifyAttributeType, ClientSettings, ConfigurationErrorEnum, ConnectionStatus, DependencyType, ErrorDetailsType, ErrorReason, ErrorType, EvergisDynamicLayer, EvergisTileLayer, External, FeatureType, Feedback, FileUpload, Filters, FontStyle, FontWeight, GEOCODE_PROVIDER, General, Geocode, GeometryType, Group, HttpClient, IceRouter, Import, Layers, LayersManager, LineCapStyle, LineEndingSize, LineEndingType, LineJoinType, Names, Namespace, Notification, NotificationEvent, Operation, Permissions, PolicyType, PortalSettings, Projects, ReferenceJoinType, ResourceCatalog, ResourceSeparator, ResourceType, ResourceTypeLink, Resources, Scheduler, Security, ServerTaskStatus, SimplifyType, SpatialProcessor, Statistic, StringSubType, Styles, Tables, TaskGroup, TextAlignment, TextVerticalAlignment, Tools, UrlPath, VectorTiles, addSubDomainToLocation, errorHandler, formDataFromFile, generateId, isEvergisDynamicLayer, isEvergisTileLayer, isFeatureLayer, isHTTPError, isHandledError, isLayer, isProjectContentItems, isString, isTileLayerService, promiseAllIgnoreErrors, stripUselessSlashes, toFormData, unique };
//# sourceMappingURL=api.esm.js.map
